//#region Grid

const gridActions = {
    ADD: 0,
    UPDATE: 1,
    REMOVE: 2,
    QUICKFILTER: 3,
    CUSTOMONE: 4
};
const gridEvents = {
    BEFORE_RENDER: 'grid-before-render',
    BEFORE_UI_INIT: 'grid-before-ui-init',
    AFTER_RENDER_: 'grid-after-render',
    AFTER_RENDER: 'grid-after-render',
    AFTER_RENDER_IMMEDIATELY: 'grid-after-immediately',
    AFTER_UI_INIT: 'grid-after-ui-init',
    AFTER_FILTER: 'grid-after-filter',
    EXPORT_START: 'grid-export-start',
    EXPORT_COMPLET: 'grid-export-complete',
    AFTER_RENDER_W_INPUTS: 'grid-after-render-with-inputs',
    AFTER_MAGIC_ERROR: 'grid-after-magic-error',
    AFTER_CHECK_ALL_CHECKBOXES: 'grid-after-check-all-checkboxes',
}
const gridResponseCodes = {
    SUCCESS: 0,
    INFO: 1,
    WARNING: 2,
    ERROR: 3,
    SHOWSPELL: 4,
}
const gridActResponseShowTypes = {
    MODAL: 0,
    TOAST: 1,
    INNER: 2
}


if (window.controls == undefined) {
    window.controls = {};
}

if ($.fn.kdrGrid == undefined) {
    $.fn.kdrGrid = {}
}


controls.grid = {
    initUI($grid) {
        let $gridTable = $grid.find('.table.kdr-grid-table, .table.kdr-grid-modal')
        loading.show($grid)

        controls.onGridBeforeUIInit($grid)

        let $gridScrollContainer = $grid.find('.kdr-grid-scroll-horizontal')
        let mcCount = $grid.find('.kdr-grid-input-tinymc-wrapper').length ? $grid.find('.kdr-grid-input-tinymc-wrapper').length : $grid.find('.kdr-grid-input-newtinymc-wrapper').length
        if (mcCount > 0 && !$grid.hasClass('kdr-grid-modal')) {
            controls.prepareTinyMCE($grid)
        }

        let $tinymceContentViews = $grid.find('.kdr-tinymce-content-view')
        if ($tinymceContentViews.length > 0) {
            for (var i = 0; i < $tinymceContentViews.length; i++) {
                let $view = $tinymceContentViews.eq(i)
                let $innerHtml = $($.parseHTML($view.prop('innerHTML')))
                let orgranizedHTML = controls.organizeElementListsInTinyMCE($innerHtml)
                if (orgranizedHTML != null) {
                    $view.html($.parseHTML(orgranizedHTML))
                }
            }
        }

        tristateCheckbox.init($grid)
        pickers.init($grid)

        $grid.find(tooltipOtions.selector).tooltip({
            delay: {
                show: tooltipOtions.delay.show,
                hide: tooltipOtions.delay.hide
            },
            boundary: tooltipOtions.boundary,
            trigger: tooltipOtions.trigger
        })

        $(tooltipOtions.selector).tooltip('hide')

        let gridTableLeftBorderWidth = Math.ceil(parseFloat($gridTable.css('border-left-width')))
        let gridTableRightBorderWidth = Math.ceil(parseFloat($gridTable.css('border-right-width')))
        function stAutoActivate() {
            function _addRmvCls($item, isAdd, isLastElement, isFirstElement) {
                if (isAdd) {
                    $item.addClass('st-auto-active')
                } else {
                    $item.removeClass('st-auto-active')
                }

                if (isLastElement && isAdd) {
                    $item.addClass('st-auto-left-last')
                } else {
                    $item.removeClass('st-auto-left-last')
                }

                if (isFirstElement) {
                    $item.addClass('st-auto-right-first')
                } else {
                    $item.removeClass('st-auto-right-first')
                }
            }

            let $firstTr = $grid.find('thead tr').eq(0)
            $grid.find('tr').each(function (j, f) {
                let $currentTr = $(f)
                let $leftItems = $currentTr.find('.st-auto-left')
                let $rightItems = $currentTr.find('.st-auto-right')


                $leftItems.each(function () {
                    let $item = $(this)

                    let y = parseInt($item.css('left'))
                    let x = Math.ceil($item.getPositionInViewport().left
                        - $grid.getPositionInViewport().left
                        - gridTableLeftBorderWidth
                        - parseFloat($item.css('border-left-width')))

                    let z = y > x && $gridScrollContainer.scrollLeft() != 0

                    let $parentTh = $firstTr.find(`[data-column-magic="${$item.data("columnMagic")}"]`)
                    let isLastActiveItem = $parentTh.index() == $firstTr.find('.st-auto-left.st-auto-active').last().index()

                    _addRmvCls($item, z, isLastActiveItem, false)
                })

                $rightItems.reverse().each((i, e) => {
                    let $item = $(e)
                    let y = parseInt($item.css('right'))
                    let x = Math.ceil($grid.getPositionInViewport().right
                        - $item.getPositionInViewport().right
                        - gridTableRightBorderWidth
                        - $gridScrollContainer.getScrollBarWidth()
                        - parseFloat($item.css('border-right-width')))

                    let z = false;

                    if ($grid.width() < $gridTable.outerWidth() - $gridScrollContainer.scrollLeft() && (y >= x)) {
                        z = true
                    }

                    let $parentTh = $firstTr.find(`[data-column-magic="${$item.data("columnMagic")}"]`)
                    let isFirstIActiveItem = $parentTh.index() == $firstTr.find('.st-auto-right.st-auto-active').first().index()

                    _addRmvCls($item, z, false, isFirstIActiveItem)
                })

            })
        }

        function initStickedColumnsOffset() {

            let $spacedColumns = [];
            function _getSpacing($arrayOfItems, itemIndex, rowIndex, isThead, position, $parentRow) {
                let spacing = 0 //= $previousCell.outerWidth() + parseInt($previousCell.css('left'))
                if (itemIndex == 0 && rowIndex == 0) {
                    spacing = 0
                } else {
                    function __calculate() {
                        for (j = itemIndex - 1; j >= 0; --j) {
                            let $item = $arrayOfItems.eq(j)
                            spacing += Math.ceil($item.outerWidth()) - 1 //Ceil is for chrome compatibility with Firefox
                        }
                    }

                    function __getDistance($element, $item, p = position) {
                        let d;
                        if (p == 'right') {
                            d = $element.getPositionInViewport()[p] - $item.getPositionInViewport()[p]
                        } else {
                            d = $item.getPositionInViewport()[p] - $element.getPositionInViewport()[p]
                        }
                        return d
                    }
                    function __findAndSetPreviousRowItemOffset($item) {
                        let colId = $item.data('columnMagic')
                        let prevColumnCellToSetOffset = columnsToSetOffset.find((e) => e.$item.data('columnMagic') == colId && e.$item.parent().hasClass('kdr-grid-header-row') == false)
                        if (prevColumnCellToSetOffset != undefined && prevColumnCellToSetOffset.$item.attr('colspan') == $item.attr('colspan') && prevColumnCellToSetOffset.$item.index() && $item.index()) {
                            //console.log(colId)
                            spacing = prevColumnCellToSetOffset.offset
                            return true
                        } else {
                            return false
                        }
                    }

                    if (isThead) {
                        if (rowIndex == 0) {
                            __calculate()
                        } else {
                            if (itemIndex == 0) {

                                let el = {
                                    $element: null,
                                    distance: 0,
                                    offset: 0
                                }

                                $($spacedColumns[rowIndex - 1]).filter((a, b) => b.$item.hasClass(`st-auto-${position}`)).each((i, e) => {
                                    let $e = e.$item
                                    let distance = __getDistance($e, $arrayOfItems.eq(itemIndex));

                                    if (i == 0 && distance >= 0) {
                                        el.$element = $e
                                        el.distance = distance
                                        el.offset = e.offset
                                    } else if ((distance >= 0 && distance <= el.distance) || (el.$element == null && (distance > -1))) {
                                        el.$element = $e
                                        el.distance = distance
                                        el.offset = e.offset

                                        if (distance == 0) {
                                            return false
                                        }
                                    }
                                })

                                let offset = el.$element == null ? el.distance : parseInt(el.offset)
                                spacing += offset

                                if (position == 'left') {
                                    if (el.$element != null && __getDistance(el.$element, $arrayOfItems.eq(itemIndex), 'left') != 0) {
                                        spacing += el.$element.outerWidth()
                                    }
                                } else {
                                    if (el.$element != null && __getDistance(el.$element, $arrayOfItems.eq(itemIndex), 'right') > 0) {
                                        spacing += el.$element.outerWidth()
                                    }
                                }
                            } else {
                                let $item = $arrayOfItems.eq(itemIndex - 1)

                                let col = $(columnsToSetOffset).map(function (x, y) {
                                    if (y.$item[0] == $item[0]) {
                                        return y
                                    }
                                })[0]

                                spacing += col.offset
                                spacing += $item.outerWidth()
                            }
                        }
                    } else {
                        let isFirstRow = $parentRow.is(':first-child')
                        if (isFirstRow == true || (isFirstRow == false && __findAndSetPreviousRowItemOffset($arrayOfItems.eq(itemIndex)) == false)) {
                            __calculate()
                        }
                    }
                }
                return spacing
            }

            function _isThead($item) {
                return $item.closest('thead').length > 0
            }
            function _manageCell($item, index, rowIndex, $items, $parentRow) {
                let isThead = _isThead($item)
                let isLeft = $item.hasClass('st-auto-left')
                let side = isLeft ? 'left' : 'right'
                let offset = _getSpacing($items, index, rowIndex, isThead, side, $parentRow)

                columnsToSetOffset.push({
                    $item: $item,
                    position: side,
                    offset: offset
                })

                if (isThead) {
                    if ($spacedColumns[rowIndex] == undefined) {
                        $spacedColumns[rowIndex] = []
                    }
                    $spacedColumns[rowIndex].push({
                        $item: $item,
                        offset: offset
                    })
                }
            }

            let columnsToSetOffset = []

            $grid.find('.kdr-grid-layout > thead, .kdr-grid-layout > tbody, .kdr-grid-layout > tfoot')
                .find('> tr.kdr-grid-item-select, > tr.kdr-grid-item-update, > tr.kdr-grid-item-insert, > tr.kdr-grid-footer, > tr.kdr-grid-header-row')
                .each((rowIndex, e) => {
                    let $row = $(e)
                    let $stAutoLeftItems = $row.find('.st-auto-left')
                    let $stAutoRightItems = $row.find('.st-auto-right').reverse()

                    $stAutoLeftItems.each((j, f) => {
                        _manageCell($(f), j, rowIndex, $stAutoLeftItems, $row)
                    })
                    $stAutoRightItems.each((j, f) => {
                        _manageCell($(f), j, rowIndex, $stAutoRightItems, $row)
                    })
                })
            $(columnsToSetOffset).each((i, e) => {
                e.$item.css(e.position, e.offset)
            })

            controls.recalculateGridTableHeaderOffets($grid)
        }
        function checkQuickFiltersWidth() {
            let $qfi = $grid.find('.kdr-grid-quick-filters-inputs')
            if ($qfi.length != 0) {
                function perform(i1) {
                    let isAnyUnder = $qfi.find('.input-group').toArray().some(e => $(e).getPositionInViewport().top > i1)

                    if (isAnyUnder) {
                        $qfi.closest('.kdr-grid-quick-filters')
                            .find('.kdr-grid-quick-filters-toggle')
                            .addClass('toggle-expanded-by-inner')
                            .find('.shaker')
                            .show()
                    } else {
                        $qfi.closest('.kdr-grid-quick-filters')
                            .find('.kdr-grid-quick-filters-toggle')
                            .removeClass('toggle-expanded-by-inner')
                            .find('.shaker')
                            .hide()
                    }
                }

                let qfiBottomEdge = $qfi.getPositionInViewport().bottom

                if ($qfi.hasClass('expanded')) {
                    $qfi.find('.kdr-grid-quick-filters-toggle').one(expander.events.EXPANDED, () => perform(qfiBottomEdge))
                    $qfi.closest('.kdr-grid-quick-filters').find('.kdr-grid-quick-filters-toggle').click()
                } else {
                    perform(qfiBottomEdge)
                }
            }
        }
        function checkHairWidth() {
            let getItemsWidth = ($items) => {
                let hairChildrensWidth = 0
                $items.each((i, e) => {
                    hairChildrensWidth += $(e).outerWidth(true)
                })

                return hairChildrensWidth
            }

            let $hair = $grid.find('.kdr-grid-hair')
            let hairAdditionClass = 'flex-wrap'

            let hairWidth = $hair.outerWidth()

            let hairChildrensWidth = getItemsWidth($hair.children())
            let diffrenceInWidth = hairChildrensWidth - hairWidth

            if ($hair.hasClass(hairAdditionClass) == false && (hairChildrensWidth > hairWidth && (diffrenceInWidth < -1 || diffrenceInWidth > 1))) {
                $hair.addClass(hairAdditionClass)
            } else {
                let $clonedHair = $hair.clone().css({ 'opacity': '0', 'position': 'absolute' }).removeClass('flex-wrap').appendTo($hair.parent())

                if (getItemsWidth($clonedHair.children()) <= hairWidth) {
                    $hair.removeClass(hairAdditionClass)
                }

                $clonedHair.remove()
            }
        }
        function initQuickFilters() {
            let $qFs = $grid.find('.kdr-grid-quick-filters')
            let $qFi = $qFs.find('.input-group')
            if ($qFi.length > 0) {
                $qFi.each((i, e) => {
                    let $input = $(e).find('.kdr-grid-quick-filter')
                    let placeholderText = ''
                    let innerWidth = 0
                    if ($input.hasClass('kdr-dropdown-w-search-item_selected')) {
                        let $inner = $input.find('.kdr-dropdown-w-search-placeholder_text')
                        placeholderText = $inner.text().trim()
                        innerWidth = $inner.innerWidth()
                    } else {
                        placeholderText = $input.attr('placeholder')
                        innerWidth = $input.innerWidth()
                    }

                    let $copiedInput = $('<span></span>')
                    $copiedInput
                        .text(placeholderText)
                        .css({
                            'font-size': $input.css('font-size'),
                            'position': 'absolute',
                            'opacity': '0',
                            'top': '-1000',
                            'left': '-1000'
                        })
                        .appendTo('body')

                    if (placeholderText != undefined && ($copiedInput.width() > innerWidth || $input.valExtended().length > 0)) {
                        $input.tooltip({
                            title: placeholderText,
                            delay: {
                                show: tooltipOtions.delay.show,
                                hide: tooltipOtions.delay.hide
                            },
                            boundary: tooltipOtions.boundary,
                            trigger: tooltipOtions.trigger
                        })
                    }
                    $copiedInput.remove()
                })

                $qFs.find('.kdr-grid-quick-filters-toggle').on(expander.events.EXPANDED, function (event) {
                    if (event.isExpanded) {
                        $qFs.addClass('kdr-grid-quick-filters-opened')
                    } else {
                        $qFs.removeClass('kdr-grid-quick-filters-opened')
                    }
                })
            }
        }
        function manageResponsiveness() {
            if ($grid.is(":visible")) {
                checkQuickFiltersWidth()
                checkHairWidth()
                initStickedColumnsOffset()
                stAutoActivate()
            }
        }

        function initResizer($table) {
            function _callback(col) {
                initStickedColumnsOffset()
                userColumns.saveColumnsInGrid($grid, col)
            }

            let $cols = $table.find('th[data-header-last-p="1"]')
            controls.initTableColumnResizer($cols, _callback)
        }


        $grid.find(".section-content .line-clamb").each((i, e) => {
            let $x = $(e);

            if ($x[0].scrollHeight > $x[0].offsetHeight) {
                $('.toggle-expanded-by-inner')
                    .show()
                    .click(function () {
                        $(this).toggleClass("toggle-expanded-by-inner-opened");
                    });
            }
        })

        controls.grid.initToggleExpanderInsideGrid($grid)


        function initDsDt() {
            $grid.find(
                '.kdr-grid-item-select [class*="ds-"],' +
                '.kdr-grid-item-select [class*="dt-"]').removeClass(function (index, item) {
                    return (item.match(/dt-\S+|ds-\S+/g) || []).join(' ');
                });

            if ($grid.hasClass('dst-override-key-for-row')) {
                function replaceCls($item, $oldClass, dataRowIndex, dataColInde) {
                    let cls = $item.attr('class')
                    cls = cls.replace($oldClass, $oldClass + `-${dataRowIndex}${dataColInde}`)
                    $item.attr('class', cls)
                    return $item
                }

                $grid.find('[class*="ds-"]').each((i, e) => {
                    let $row = $(e).closest('.kdr-grid-item-update, .kdr-grid-item-insert')
                    let rMatches = $(e).attr('class').match(/ds-(\S+)/i)
                    let groupIndex = rMatches[1]
                    let $rowIndexHolder = $(e).closest('[data-row-index]') //przewaznie bedzie to <td></td>
                    let rowIndex = $rowIndexHolder.data('rowIndex')
                    let colIndex = $rowIndexHolder.find('.kdr-grid-input[data-index]').data('index')

                    replaceCls($(e), rMatches[0], rowIndex, colIndex)

                    $row.find('[class*="dt-' + groupIndex + '"], [class*="da-' + groupIndex + '"]').each((j, f) => {
                        let classes = $(f).attr('class')
                        let regexMatches = classes.match(/(?:dt|da)-(\S+)/i)

                        replaceCls($(f), regexMatches[0], rowIndex, colIndex)
                    })
                })
            }

            $grid.find('tr:not(.kdr-item-select) .kdr-grid-input[class*="ds"]').trigger('disabler')
        }

        let $tabsObjects = $grid.parents('[id^="tabs"]')
        if ($tabsObjects.length != 0) {
            let dataKey = `gridinit.initedGridTabsParent.${$grid.attr('id')}`

            $grid.parents('.tab-pane').map((i, e) => e.id).each((i, e) => {
                let $tab = $('[data-toggle="tab"][href="#' + e + '"]')
                if ($tab.data(dataKey) !== true) {

                    $tab.on('shown.bs.tab', function () {
                        manageResponsiveness()
                    })

                    $tab.data(dataKey, true)
                }
            })
        }

        let $expandableObjects = $grid.parents('.tilemenu-row')
        if ($expandableObjects.length != 0) {
            let dataKey = `gridinit.initedGridCollapseParent.${$grid.attr('id')}`
            let collapsePanelId = $expandableObjects.find('.tilemenu-row-header').data('target')
            let $eventCatchers = $expandableObjects.find(collapsePanelId).filter(function () { return $(this).data(dataKey) !== true })

            $eventCatchers.on('shown.bs.collapse', function () {
                manageResponsiveness()
            })
            $eventCatchers.data(dataKey, true)
        }

        let $carouselParent = $grid.parents('.carousel')
        if ($carouselParent.length != 0) {
            $carouselParent.on('slid.bs.carousel', manageResponsiveness)
        }

        $(window).bind('resize', false, function () {
            manageResponsiveness()
        })

        $gridScrollContainer.on('scroll', false, function () {
            stAutoActivate()
        })

        initQuickFilters()
        manageResponsiveness()

        $grid.find('.check-text-color-visibility').each((i, e) => {
            let $item = convert.toJqueryObject(e)
            let bgColor = $item.css('background-color')
            if (bgColor != undefined && checkColor.isDark(bgColor)) {
                $item.addClass('text-white')
            }

        })

        if ($grid.hasClass('kdr-grid-flip')) {
            let $table = $grid.find('.kdr-grid-layout')

            let newrows = []

            //$table.find("tr").each(function () {
            //    var i = 0;
            //    $(this).find("td,th").each(function () {
            //        i++;
            //        if (newrows[i] === undefined) {
            //            newrows[i] = $("<tr></tr>")
            //        }

            //        newrows[i].append($(this))
            //    });
            //});

            let $trs = $table.find("tr")
            for (var i = 0; i < $trs.length; i++) {
                let $tr = $trs.eq(i)

                $tr.find("td,th").each((j, e) => {
                    if (newrows[j] === undefined) {
                        newrows[j] = $("<tr></tr>").addClass('kdr-grid-item-update d-table-row') //fixme 
                    }

                    newrows[j].append($(e))
                })
            }


            $table.find("tr").remove()
            $.each(newrows, function () {
                $table.append(this)
            });

            $table.fadeOut(0)
            $grid.removeClass('hidden')
            $table.fadeIn(500)
        }

        if ($gridTable.length > 0) {
            initResizer($gridTable)
            $gridTable.each((i) => {
                $gridTable.eq(i).data('headerHeight', $gridTable.eq(i).find('thead').outerHeight())
            })
        }

        initDsDt()

        loading.hide($grid)

        let areConnectedTabsFiltersByCommandsP = false
        let gridId = $grid.prop('id')
        $('.kdr-commands[value*="' + gridId + '"]').each((i, tbc) => {
            let $tbc = $(tbc)
            let connectedTabsFiltersByCommandsP = JSON.parse($tbc.valExtended())
                .filter(x => x.Target == gridId /*&& x.CountTargetElementsP === true */ && (x.Action == 1 || x.Action == 4));

            areConnectedTabsFiltersByCommandsP = connectedTabsFiltersByCommandsP.length != 0

            connectedTabsFiltersByCommandsP
                .filter(x => x.CountTargetElementsP === true)
                .forEach(comm => {

                    let $tabFilter = $(`#${comm.Root}`)
                    if ($tabFilter.length > 0) {
                        let args = []

                        $tabFilter.find('.kdr-filters-tabs-filter-new-order').each((i, e) => {
                            args.push({
                                index: $(e).data('index'),
                                value: $(e).data('value'),
                                item: $(e)
                            })
                        })

                        function _gridStillExistsOnDOMP() {
                            //let b = $grid.closest('html').length != 0;
                            //console.info(b ? `${$grid.prop('id')} is alive` : `${$grid.prop('id')} is dead`)
                            return $grid.existOnDOMP()
                        }

                        setTimeout(() => {
                            $(args).each((i, e) => {
                                let arg = {}
                                arg[e.index] = e.value
                                let $loadingIndicator = e.item.find('.tab-filter-items-count')
                                setTimeout(() => {
                                    if (_gridStillExistsOnDOMP() === true) {
                                        $.ajax({
                                            type: "POST",
                                            url: __root + "Filters/Change",
                                            datatype: "json",
                                            traditional: true,
                                            data: {
                                                "info": controls.getInfo($tabFilter),// $tabFilter.find(".kdr-info").val(),
                                                "args": JSON.stringify(arg)
                                            },
                                            success: function (response) {
                                                if (_gridStillExistsOnDOMP() === true) {
                                                    $.ajax({
                                                        type: "POST",
                                                        url: __root + "Filters/AdvancedFilter",
                                                        datatype: "json",
                                                        traditional: true,
                                                        data: {
                                                            'control': controls.getInfo($grid),
                                                            'filters': response.info,
                                                            'clearQFP': e.item.hasClass('active') === false
                                                        },
                                                        success: function (response2) {
                                                            if (_gridStillExistsOnDOMP()) {
                                                                $.ajax({
                                                                    type: "POST",
                                                                    url: __root + "Grid/GetGridElementsCount",
                                                                    datatype: "json",
                                                                    traditional: true,
                                                                    data: {
                                                                        "info": response2.info
                                                                    },
                                                                    success: function (response3) {
                                                                        if (_gridStillExistsOnDOMP() === true) {
                                                                            if (response.code == gridResponseCodes.SUCCESS) {
                                                                                $(e.item).trigger({
                                                                                    type: 'setItemsCount',
                                                                                    count: response3.message
                                                                                })
                                                                            }
                                                                        }
                                                                    },
                                                                    beforeSend: () => loading.show($loadingIndicator),
                                                                    complete: () => loading.hide($loadingIndicator)
                                                                })
                                                            }
                                                        },
                                                        beforeSend: () => loading.show($loadingIndicator),
                                                        complete: () => loading.hide($loadingIndicator)
                                                    })
                                                }
                                            },
                                            beforeSend: () => loading.show($loadingIndicator),
                                            complete: () => loading.hide($loadingIndicator)
                                        })
                                    }
                                })
                            }, 1)
                        }, 1)
                    }
                })
        })

        if (areConnectedTabsFiltersByCommandsP === false) {
            let $tabContainer = $grid.closest(".tab-pane")
            if ($tabContainer.isAny() && $tabContainer.find('.kdr-grid .kdr-grid-content').length == 1 && !$grid.hasClass('dismiss-on-tab-counter')) {
                $grid.addClass('default-tab-counter')
            }
        }

        controls.onGridAfterUiInit($grid)

    },
    toggleGridFullscreen($grid) {
        function _findRelativeParents($item, parents = []) {
            let $p = $item.parent()

            if ($p.is('body')) {
                return parents;
            } else {
                if ($p.css('position') == 'relative') {
                    parents.push($p)
                }
                return $(_findRelativeParents($p, parents))
            }
        }
        let $btn = $grid.find('.kdr-grid-toggle-fullscreen')
        let currentState = $btn.data('state')

        $.ajax({
            type: "POST",
            url: __root + 'Grid/ToggleGridFullscreen',
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo($grid),
                "stateP": currentState,
            },
            success: function (response) {
                if (response.code == gridResponseCodes.SUCCESS) {
                    let newState = response.args[0]
                    controls.setInfo($grid, response.info)

                    $btn.data('state', newState)
                    $grid.toggleClass('kdr-grid-fullscreen')
                    $grid.find('.kdr-grid-content').toggleClass('kdr-grid-scroll-horizontal')
                    $btn.find('.maximize-container, .minimize-container').toggle()

                    let isMaximizing = newState
                    let $b = $('body')
                    let bStyles = $b.attr('style')?.split(';') ?? []
                    let style = 'overflow: clip !important'

                    if (JSON.parse(isMaximizing.toLowerCase())) {
                        let $firstLineParent = $grid.parent()
                        $('<div></div>')
                            .data('gridFirstLineParent', $firstLineParent)
                            .addClass('kdr-grid-fullscreen-container')
                            .css('top', window.scrollY)
                            .css('z-index', modal.getFirstHighestUsableZIndex())
                            .data('DOMItemIndex', $grid.index())
                            .append($grid)
                            .appendTo($b)

                        bStyles.push(style)

                    } else if ($grid.closest('.kdr-grid-fullscreen-container').length > 0 && JSON.parse(isMaximizing.toLowerCase()) == false) {
                        let $containerParent = $grid.closest('.kdr-grid-fullscreen-container')
                        let $primaryParent = $containerParent.data('gridFirstLineParent')

                        $grid.appendToWithIndex($primaryParent, $containerParent.data('DOMItemIndex'))
                        $containerParent.remove()

                        bStyles.pop(style)
                    }

                    $b.attr('style', bStyles.join(';'))

                    controls.recalculateGridTableHeaderOffets($grid)
                } else {
                    toastr[toastrTypes[response.code]](response.message)
                }
            },
            beforeSend: function () {
                loading.show($grid)
            },
            complete: () => {
                loading.hide($grid)
            }
        })
    },
    toggleTextareas($grid, showP, $loadingIndicator) {

        if (showP === true) {
            $grid.find('.resizable-vertical').addClass('h-auto').css('height', '')
        } else {
            $grid.find('.resizable-vertical').removeClass('h-auto')
        }

        $.ajax({
            type: "POST",
            url: window.location.origin + __root + 'Grid/ToggleTextareas',
            datatype: "json",
            traditional: true,
            data: {
                info: controls.getInfo($grid),
                showP: showP
            },
            success: function (response) {
                if (3 != response.code) {
                    controls.setInfo($grid, response.info)
                } else {
                    modal.getModal.danger(__l.Error, response.message, true)
                }
            },
            beforeSend: function () { loading.show($loadingIndicator) },
            complete: function () { loading.hide($loadingIndicator) },
        })
    },
    switchLayoutAndRefresh($grid, targetLayout) {
        $.ajax({
            type: "POST",
            url: __root + "Grid/SwitchGridLayout",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo($grid),
                "targetLayout": targetLayout,
            },
            success: function (response) {
                controls.magic(controls.getEndpoint($grid), $grid, response, $grid)
            }
        })
    },
    initToggleExpanderInsideGrid($grid) {
        $grid.find(".toggle-expanded-by-inner-target").each((i, e) => {
            let $x = $(e);

            if ($x.data('togglerInitedP') === true || $x.is(":visible") === false) return;

            let clambId = $x.prop('id')
            let $toggler = $('.toggle-expanded-by-inner[data-target="#' + clambId + '"]')

            if ($x.isAny() && $x[0].scrollHeight > $x[0].offsetHeight) {
                let lcCls = /(line-clamb-\d)/gm.exec($x.prop('class'))[0] ?? null
                $x.css('max-height', $x.css('height'))

                $toggler
                    .on(expander.events.BEFORE_EXPANDING, (e) => {
                        if (e.willExpandP) {
                            $x.removeClass(lcCls)
                        }
                    }).on(expander.events.EXPANDED, (e) => {
                        if (!e.isExpanded) {
                            $x.addClass(lcCls)
                        }
                    })

                $toggler.show()

                $x.data('togglerInitedP', true)
            }
        })
    }
}

Object.defineProperty($.fn, 'kdrGrid', {
    get: function () {
        const self = this;

        return {
            initUI: function () {
                return self.each(function () {
                    controls.grid.initUI(convert.toJqueryObject(this))
                });
            },
            refresh: function () {
                return self.each(function () {
                    controls.refresh(convert.toJqueryObject(this))
                });
            },
            toggleGridFullscreen: function () {
                return self.each(function () {
                    controls.grid.toggleGridFullscreen(convert.toJqueryObject(this))
                });
            },
            toggleTextareas: function (showP, $loadingIndicator) {
                return self.each(function () {
                    controls.grid.toggleTextareas(convert.toJqueryObject(this), showP, $loadingIndicator)
                });
            },
            switchLayoutAndRefresh: function (targetLayout) {
                return self.each(function () {
                    controls.grid.switchLayoutAndRefresh(convert.toJqueryObject(this), targetLayout)
                });

            }
        };
    }
})

$(document).on('click', '.kdr-grid-change-language', function () {
    let $this = $(this)
    if ($this.closest('.btn-group').data('changingP') === true) {
        return false
    }
    else {
        $this.closest('.btn-group').data('changingP', true)
    }

    let languageCode, rowIndex

    if ($this.hasClass('kdr-dropdown-w-search-item')) {

        let $ddl = $('.kdr-dropdown-w-search-input[data-target=' + $this.closest('.dropdown-menu').attr('id') + ']')

        languageCode = $this.data('value')
        rowIndex = $ddl.data('index')

        $ddl.closest('td,.modal-body,.kdr-grid').find('td[data-language]' + ((rowIndex != -1) ? '[data-row-index=' + rowIndex + ']' : '') + ':not([data-language=' + languageCode + '])').hide()
        $ddl.closest('td,.modal-body,.kdr-grid').find('td[data-language=' + languageCode + ']' + ((rowIndex != -1) ? '[data-row-index=' + rowIndex + ']' : '')).show()
    }
    else {

        languageCode = $this.data('language')
        rowIndex = $this.data('rowIndex')
        $this.siblings().removeClass('language-active')
        $this.addClass('language-active')
        $this.closest('td,.modal-body,.kdr-grid').find('td[data-language]' + ((rowIndex != -1) ? '[data-row-index=' + rowIndex + ']' : '') + ':not([data-language=' + languageCode + '])').hide()
        $this.closest('td,.modal-body,.kdr-grid').find('td[data-language=' + languageCode + ']' + ((rowIndex != -1) ? '[data-row-index=' + rowIndex + ']' : '')).show()
        $this.closest('.btn-group').data('changingP', false)
    }
    let $ddlsToInform = $this.closest('td, .modal-body, .kdr-grid')
        .find('.kdr-dropdown-w-search-input-w-a-w-lang')

    for (var i = 0; i < $ddlsToInform.length; i++) {
        let $toggler = $ddlsToInform.eq(i)
        $toggler.trigger({
            type: 'kdr.changedDisplayedLang',
            newLangCode: languageCode
        })
    }

})

$(document).on("click", ".kdr-grid-sort", function () {
    let $this = $(this)
    /*let $thisParent = $this.closest('th')*/
    let $grid = $this.closest(".kdr-grid")
    let index = $this.data("index")
    let ascendingP = ($this.data("sort") == "ASC") ? true : false
    let gridId = "#" + $grid.attr("id")

    let func = function () {
        $grid = $(gridId)
        $.ajax({
            type: "POST",
            url: __root + "Grid/Sort",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo($grid),
                "index": index,
                "ascendingP": ascendingP
            },
            success: function (response) {
                $grid = $(gridId)
                controls.magic("Grid/Render", $grid, response, $grid /*$thisParent*/)
            }
        })
    }

    let func2 = function (callback) {
        if ($grid.hasClass('kdr-grid-lock-checkboxes')) {
            controls.lockCheckboxes($grid, callback)
        }
        else {
            callback && callback()
        }
    }

    if ($grid.hasClass('kdr-grid-save-all-on-sort-change')) {
        func2(function () {
            $(document).one(gridEvents.BEFORE_RENDER, gridId, function (event) {
                if (event.code == gridResponseCodes.SUCCESS) {
                    $(document).one(gridEvents.AFTER_RENDER, gridId, func)
                }
            })
            $grid.find('.kdr-grid-save-all').click()
        })

    } else {
        func2(func)
    }
})

$(document).on("click", ".kdr-grid-page", function () {
    let that = $(this)
    //""let $thisParent = that.closest('.page-item')
    let $grid = that.closest(".kdr-grid")
    let page = that.attr("data-page")
    let gridId = "#" + $grid.attr("id")

    let func = function () {
        $grid = $(gridId)
        $.ajax({
            type: "POST",
            url: __root + "Grid/Page",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo($grid),
                "page": page
                //"page": that.attr("data-page")
            },
            success: function (response) {
                $grid = $(gridId)
                controls.magic("Grid/Render", $grid, response, $grid /*$thisParent*/)
                //controls.onGridAfterRender(grid, undefined, undefined)
            }
        })
    }

    let func2 = function (callback) {
        if ($grid.hasClass('kdr-grid-lock-checkboxes')) {
            controls.lockCheckboxes($grid, callback)
        }
        else {
            callback && callback()
        }
    }

    if ($grid.hasClass('kdr-grid-save-all-on-page-change')) {
        func2(function () {
            $(document).one(gridEvents.BEFORE_RENDER, gridId, function (event) {
                if (event.code == gridResponseCodes.SUCCESS) {
                    $(document).one(gridEvents.AFTER_RENDER, gridId, func)
                }
            })

            $grid.find('.kdr-grid-save-all').click()
        })
    } else {
        func2(func)
    }
})

$(document).on('focus', '.page-link #page-number', function () {
    this.select()
})

$(document).on("change", ".page-link #page-number", function (event) {
    let that = $(this)
    let grid = that.closest(".kdr-grid")
    let $loadingIndicator = that.closest('.page-link')

    function func() {
        $.ajax({
            type: "POST",
            url: __root + "Grid/Page",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo(grid),
                "page": that.val() - 1
            },
            success: function (response) {
                controls.magic("Grid/Render", grid, response, grid)
                //controls.onGridAfterRender(grid, undefined, undefined)
            },
            beforeSend: function () { loading.show($loadingIndicator) },
            complete: function () { loading.hide($loadingIndicator) },
        })
    }

    if ($grid.hasClass('kdr-grid-lock-checkboxes')) {
        controls.lockCheckboxes(grid, func)
    }
    else {
        func()
    }
})
$(document).on("click", ".kdr-grid-all-letters", function () {
    $(this).closest('.pagination').find('.page-item.active .kdr-grid-letter').click()
})
$(document).on("click", ".kdr-grid-letter", function () {
    let that = $(this)
    let $thisParent = that.closest('.page-item')
    let grid = that.closest(".kdr-grid")

    function func() {
        $.ajax({
            type: "POST",
            url: __root + "Grid/Letter",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo(grid),
                "letter": that.attr("data-letter")
            },
            success: function (response) {
                controls.magic("Grid/Render", grid, response, $thisParent)
            }
        })
    }

    if (grid.hasClass('kdr-grid-lock-checkboxes')) {
        controls.lockCheckboxes(grid, func)
    }
    else {
        func()
    }
})

///Zezwala tylko na wprowadzanie wartosci liczbowych
$(document).on("input keydown keyup blur drop paste", ".kdr-grid-numeric, .kdr-numeric", function (event) {
    let $this = $(this)

    if ($this.data('numericInputValidatiorOn') !== true) {
        let regex;

        let groupSeparator = $this.data('groupSeparator')
        if (groupSeparator == ' ') {
            groupSeparator = ' '

        }
        if ($this.data('numericType') == 'decimal') {
            let decimalSeparator = $this.data('decimalSeparator')
            regex = new RegExp(`^-?\\d*[${decimalSeparator}]?\\d*$`)
        } else {
            regex = /^-?[0-9]*$/
        }

        $this.inputFilter(function (value) {
            let isValueValid = regex.test(value)

            $this.data('valueIsInvalid', !isValueValid)
                .trigger({
                    type: 'kdr',
                    namespace: 'checkedValueCorrectness',
                    hasInvalidValue: !isValueValid,
                    newValue: value
                })

            return isValueValid;
        });

        $this.data('numericInputValidatiorOn', true)
    }
})

$(document).on("keydown", ".kdr-filter-numeric", function (event) {
    let legalKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'ArrowLeft', 'ArrowRight', 'Delete']

    if (!legalKeys.some(x => x == event.originalEvent.key)) {
        event.preventDefault();
    }
})

$(document).on("click", ".kdr-grid-items", function () {
    let that = $(this)
    let grid = that.closest(".kdr-grid")
    let $loadingIndicator = grid
    //$loadingIndicator.push(that.closest('.pagination-dropdown'))

    function func() {
        $.ajax({
            type: "POST",
            url: __root + "Grid/Items",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo(grid),
                "items": that.data("value")
            },
            success: function (response) {
                controls.magic("Grid/Render", grid, response, $loadingIndicator)
            }
        })
    }

    if (grid.hasClass('kdr-grid-lock-checkboxes')) {
        controls.lockCheckboxes(grid, func)
    }
    else {
        func()
    }
})

$(document).on("click", ".kdr-grid-toggle-checkbox-filter", function () {
    let $this = $(this)
    let $grid = $this.closest(".kdr-grid")
    let columnMagic = $this.closest('td').data('columnMagic')
    controls.lockCheckboxes($grid, function () {
        controls.toggleCheckboxFilter($grid, columnMagic, function () {
            controls.refresh($grid)
        })
    })
})

$(document).on("click", ".kdr-grid-edit", function () {
    let $gridEditButton = $(this)
    let $table = $gridEditButton.closest(".kdr-grid-layout")
    let visibleUpdateItemsCount = $table.find('.kdr-grid-item-update:visible').length

    if (visibleUpdateItemsCount > 0) {
        modal.getModal.warning("~{Warning}", "~{Finish the previous edition.}", true)
        return
    } else {
        let $selectRow = $gridEditButton.closest(".kdr-grid-item-select")
        let $langRow = $gridEditButton.closest(".kdr-grid").find(".kdr-grid-change-language-list")
        //let $parent = $selectRow.parent()
        let $updateRow = $selectRow.next() //$parent.children().eq($selectRow.index() + 1)
        if ($updateRow.hasClass('toggle-row')) $updateRow = $updateRow.next()

        $selectRow.addClass('hide')//.hide()
        $updateRow.addClass('show')//.show()
        $langRow.removeClass('hide')

        $table.find('.kdr-grid-move-wrapper').hide()

        let langP = $table.closest('.kdr-grid').find('.kdr-grid-change-language-list')
        if (langP.isAny()) {
            let isInlineInsert = $table.find('.kdr-grid-item-insert').isAny()
            if (isInlineInsert == true) {
                //nice nie rob
            } else {
                langP.show()
            }
        }
    }
})

$(document).on("click", ".kdr-grid-cancel", function () {
    let $that = $(this)
    let $table = $that.closest(".kdr-grid-layout")
    let $update = $that.closest(".kdr-grid-item-update")
    let lang = $that.closest(".kdr-grid").find(".kdr-grid-change-language-list")
    //let $parent = $update.parent()

    let $select = $update.prev() //$parent.children().eq($update.index() - 1)
    if ($select.hasClass('toggle-row')) $select = $select.prev()


    $select.removeClass('hide')
    $update.removeClass('show')
    lang.addClass('hide')

    $table.find('.kdr-grid-move-wrapper').show()


    let langP = $table.closest('.kdr-grid').find('.kdr-grid-change-language-list')
    if (langP.isAny()) {
        let isInlineInsert = $table.find('.kdr-grid-item-insert').isAny()
        if (isInlineInsert == true) {
            //nice nie rob
        } else {
            langP.hide()
        }
    }
})

$(document).on("click", ".kdr-grid-edit-all", function () {
    let that = $(this)
    let table = that.closest(".kdr-grid")
    table.find(".kdr-grid-item-select").addClass('hide')
    table.find(".kdr-grid-item-update").addClass('show')
    table.find(".kdr-grid-cancel-all").show().addClass('show') //baghdad
    table.find(".kdr-grid-save-all").show().addClass('show')
    that.hide()
})

$(document).on("click", ".kdr-grid-cancel-all", function () {
    let that = $(this)
    let table = that.closest(".kdr-grid")

    table.find(".kdr-grid-item-select").removeClass('hide')
    table.find(".kdr-grid-item-update").removeClass('show')
    table.find(".kdr-grid-edit-all").show().addClass('show')   //baghdad
    table.find(".kdr-grid-save-all").hide().removeClass('show')
    that.hide().removeClass('show')
})

$(document).on("click", ".kdr-grid-save", function () {
    let $this = $(this)
    let $grid = $this.closest(".kdr-grid")
    let gridId = $grid.attr('id')
    let inputs;

    let files = controls.getFiles(gridId)
    let progressText = files != undefined && files.length > 0 ? __l.Sending : undefined

    let ordinal = $this.closest("td").data("itemOrdinal")

    if (ordinal != null) {
        inputs = $grid.find('td[data-item-ordinal="' + ordinal + '"] .kdr-grid-input')
    }
    else {
        ordinal = $this.closest("div.oridinal-class").attr('data-item-ordinal')
        inputs = $grid.find('div[data-item-ordinal="' + ordinal + '"] .kdr-grid-input');
    }
    /*console.log(ordinal)*/

    if (inputs.length === 0) {
        ordinal = $this.closest(".oridinal-class").data("itemOrdinal");
        inputs = $grid.find('.oridinal-class[data-item-ordinal="' + ordinal + '"] .kdr-grid-input');
    }

    let args = {}
    controls.getArgs(inputs, args)

    let formData = new FormData();
    formData.append('info', controls.getInfo($grid))
    formData.append('magic', $this.attr("data-action"))
    formData.append('args', JSON.stringify(args))
    if (controls.appendFilesToFormData(formData, files, $grid) === false) {
        return false
    }

    let $loadingTarget = null
    if ($grid.closest('.modal').length == 0) {
        $loadingTarget = $grid
    } else {
        $loadingTarget = $grid.closest('.modal-content')
    }


    $.ajax({
        type: "POST",
        url: __root + "Grid/Act",
        datatype: "json",
        traditional: true,
        contentType: false,
        processData: false,
        data: formData,
        success: function (response) {
            controls.onGridBeforeRender($grid, response.code, gridActions.UPDATE, response.info, response.returnValue);
            controls.magic("Grid/Render", $grid, response, $loadingTarget)
        },
        beforeSend: function () { loading.show($loadingTarget, undefined, undefined, progressText) },
        complete: function () {
            loading.hide($loadingTarget);
        },
        error: function () {

            if (files != undefined && files.length > 0) {
                modal.getModal.danger(__l.Error, '~{Add file(s) again, some has been changed in another window.}', true
                    , undefined, undefined, undefined, undefined, undefined, $grid) //zabijcie mnie
            }
        },
        xhr: function () {
            var xhr = new window.XMLHttpRequest();
            if (files != undefined && files.length > 0) {
                let $progressTextOnDOM = $loadingTarget.find('.waitMe .waitMe_text')

                $loadingTarget.find('.waitMe .waitMe_text').text(__l.Sending)

                xhr.upload.addEventListener('progress', function (evt) {
                    if (evt.lengthComputable) {
                        let percentComplete = parseInt((evt.loaded * 100) / evt.total)
                        let newText = __l.SendingWithValue.replace('{0}', percentComplete + '%')
                        $progressTextOnDOM.text(newText)
                    }
                }, false)

                xhr.upload.addEventListener('loadend', function () {
                    if ($progressTextOnDOM.length > 0) {
                        $progressTextOnDOM.text(__l.Computing)
                    }
                }, false)
            }

            return xhr;
        }
    })
})

let eraserClicked = false;
$(document).on("click", ".kdr-grid-quick-filter-clear", function () {
    let $inputContainer = $(this).closest('.input-w-eraser')
    let $input = $inputContainer.find('.kdr-grid-quick-filter')
    let val = $input.valExtended()

    if (val.length > 0 && val != '') {
        $input.valExtended('')
        $inputContainer.closest('.kdr-grid-quick-filters').find('.kdr-grid-quick-filter-action').click()
    }
    eraserClicked = true;
})

$(document).on("click", ".kdr-grid-quick-filters-clear-all", function () {
    let $btn = $(this)

    let $grid = $btn.closest(".kdr-grid")
    let gridInfo = controls.getInfo($grid)

    $.ajax({
        type: "POST",
        url: __root + "Grid/QuickFiltersClearAll",
        datatype: "json",
        traditional: true,
        data: {
            "info": gridInfo
        },
        success: function (response) {
            controls.onGridBeforeRender($grid, response.code, gridActions.QUICKFILTER);
            controls.magic("Grid/Render", $grid, response)
        },
        beforeSend: () => loading.show($btn),
        complete: () => loading.hide($btn)

    })
})

function validateQF($qf) {
    if ($qf.hasClass('time-from-to') || $qf.hasClass('date-time-from-to')) {

        let thisVal = $qf.valExtended()

        if (textHelper.isNullOrEmpty(thisVal)) {
            return true
        }
        else if (thisVal.includes('_')) {
            return false
        }
        else if ($qf.data('xdsoft_datetimepicker')?.is(':visible')) {
            return false
        }


        let dateTimeModeP = $qf.hasClass('date-time-from-to')
        let thisMode = $qf.data('timeMode')
        let colIndex = $qf.data('index')
        let secVal = $(`[data-index="${colIndex}"][data-time-mode="${(thisMode == 'from' ? 'to' : 'from')}"]`).valExtended()

        let timeFrom;
        let timeTo;

        if (dateTimeModeP === true) {
            timeFrom = new Date(thisMode == 'from' ? thisVal : secVal)
            timeTo = new Date(thisMode == 'from' ? secVal : thisVal)
        } else {
            const _createDateFromTime = (time) => new Date("1970-01-01T" + time);
            if (thisMode == 'to' && (isNaN(_createDateFromTime(thisVal)) || (_createDateFromTime(thisVal) >= new Date("1970-01-02T00:00")))) {
                $qf.addClass('has-error')
                return false
            }
            else
                timeFrom = _createDateFromTime(thisMode == 'from' ? thisVal : secVal)
            timeTo = _createDateFromTime(thisMode == 'from' ? secVal : thisVal)
        }

        if (textHelper.isNullOrEmpty(secVal)) {
            return true
        }

        let isCorrect = timeFrom <= timeTo

        if (isCorrect == false) {
            $qf.addClass('has-error')
        }
        else {
            $qf.removeClass('has-error')
        }

        return isCorrect

    } else {
        return true
    }
}


$(document).on("xdSoft.closed", ".kdr-grid-quick-filter", function (e) {
    $(this).closest('.kdr-grid').find('.kdr-info').focus()
})

$(document).on("change", ".kdr-grid-quick-filter", function (e) {
    let $qf = $(this)

    if (!eraserClicked
        && ($qf.valExtended() != $qf.data('oldValue'))
        && $qf.closest('.kdr-grid-quick-filters-inputs').find('*:active').length == 0
        && validateQF($qf)) {
        $qf.closest('.kdr-grid-quick-filters').find('.kdr-grid-quick-filter-action').click()
    };
})

$(document).on("keypress", ".kdr-grid-quick-filter", function (e) {
    if (e.keyCode == 13 && validateQF($(this))) {
        $(this).closest('.kdr-grid-quick-filters').find('.kdr-grid-quick-filter-action').click()
    }
})


$(document).on("click", ".kdr-grid-quick-filter-action", function () {
    let $this = $(this)
    let $grid = $this.closest(".kdr-grid")

    let item = $this.closest(".kdr-grid-quick-filters")
    let $inputs = item.find(".kdr-grid-quick-filter")

    let gridId = "#" + $grid.attr("id")

    let args = {}
    controls.getArgs($inputs, args)

    for (var i = 0; i < $inputs; i++) {
        let $i = $inputs.eq(i)
        if ($i.hasClass('time-from-to') && $i.hasClass('has-error')) {
            args[$i.data('index')][$i.data('timeMode')] = null
        }
    }

    let formData = new FormData();
    formData.append('quickFilters', JSON.stringify(args))

    let func2 = function (callback) {
        if ($grid.hasClass('kdr-grid-lock-checkboxes')) {
            controls.lockCheckboxes($grid, callback)
        }
        else {
            callback && callback()
        }
    }

    let func = function () {
        $grid = $(gridId)
        formData.append('info', controls.getInfo($grid))
        $.ajax({
            type: "POST",
            url: __root + "Grid/QuickFilter",
            datatype: "json",
            traditional: true,
            contentType: false,
            processData: false,
            data: formData,
            success: function (response) {
                controls.onGridBeforeRender($grid, response.code, gridActions.QUICKFILTER);
                controls.magic("Grid/Render", $grid, response)
            },
            beforeSend: function () { loading.show($grid) },
            complete: function () { loading.hide($grid); eraserClicked = false }
        })
    }

    let $saveAll = $grid.find('.kdr-grid-save-all')

    if ($grid.hasClass('kdr-grid-save-all-on-quick-filter-change') && $saveAll.length > 0) {
        func2(function () {
            $(document).one(gridEvents.BEFORE_RENDER, gridId, function (event) {
                if (event.code == gridResponseCodes.SUCCESS) {
                    $(document).one(gridEvents.AFTER_RENDER, gridId, func)
                }
            })

            $saveAll.click()
        })
    } else {
        func2(func)
    }
})

$(document).on("click", ".kdr-grid-move", function () {
    let $this = $(this)
    let grid = $this.closest(".kdr-grid")

    $.ajax({
        type: "POST",
        url: __root + "Grid/Act",
        datatype: "json",
        traditional: true,
        data: {
            "info": controls.getInfo(grid),
            "magic": $this.attr("data-action"),
            "args": null
        },
        success: function (response) {
            controls.onGridBeforeRender(grid, response.code, gridActions.REMOVE);
            controls.magic("Grid/Render", grid, response, grid)
        },
        beforeSend: function () {
            loading.show($this)
        },
        complete: function () {
            loading.hide($this)
        }
    })
})

$(document).on("click", ".kdr-grid-remove", function () {
    let $this = $(this)
    let $grid = $this.closest(".kdr-grid")
    let $modal = $grid.find(".kdr-grid-delete-modal").clone().detach()
    let mId = $modal.prop('id') + 'clonedDetached'
    let $loadingTarget = $grid.closest('.modal').length > 0 ? $grid.closest('.modal-content') : $grid

    let op = "Update"
    let actions = $grid.find(".kdr-grid-save-action[data-operation-type=" + op + "]")
    let payload = []
    actions.each(function (a, b) {
        let c = $(b)
        let item = c.closest(".kdr-grid-item-update")
        //let inputs = item.children().children(".kdr-grid-input")
        let inputs = item.find(".kdr-grid-input")
        let args = {}
        controls.getArgs(inputs, args)
        payload.push(
            {
                magic: c.attr("data-action"),
                args: args
            })
    })

    $modal.prop('id', mId)
    $('body').append($modal)

    modal.prepareModal(mId);

    $modal.on('hidden.bs.modal', function () {
        $modal.remove()
    })

    $modal.find(".kdr-grid-remove-confirm").click(function () {
        $modal.modal("hide")
        $.ajax({
            type: "POST",
            url: __root + "Grid/Act",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo($grid),
                "magic": $this.attr("data-action"),
                "args": null,
                "payload": JSON.stringify(payload)
            },
            success: function (response) {
                controls.onGridBeforeRender($grid, response.code, gridActions.REMOVE, response.info, response.returnValue);
                controls.magic("Grid/Render", $grid, response, $loadingTarget)
                $modal.modal("hide")
            },
            beforeSend: function () { loading.show($loadingTarget) },
            complete: function () { loading.hide($loadingTarget) }
        })
    })
    $modal.modal("show")
})

$(document).on("click", ".kdr-grid-custom-one", function () {

    let that = $(this)
    let grid = that.closest(".kdr-grid")
    let gridId = grid.prop('id')

    //let $modal = grid.find(".kdr-grid-delete-modal").clone().detach()
    //let mId = $modal.prop('id') + 'clonedDetached'

    //let op = that.attr("data-operation-type")
    let lockRenderSourceP = that.data('lock-render-source-p')

    let op = "Update"
    let actions = $(grid).find(".kdr-grid-save-action[data-operation-type=" + op + "]")
    let payload = []
    actions.each(function (a, b) {
        let c = $(b)
        let item = c.closest(".kdr-grid-item-update")
        //let inputs = item.children().children(".kdr-grid-input")
        let inputs = item.find(".kdr-grid-input")
        let args = {}
        controls.getArgs(inputs, args)
        payload.push(
            {
                magic: c.attr("data-action"),
                args: args
            })
    })

    let btnLoadingTarget = that.data('loading-target')
    let $loadingTargets = null


    if (textHelper.isNullOrEmpty(btnLoadingTarget) == false) {
        $loadingTargets = $(btnLoadingTarget)
    }
    else if (grid.closest('.modal').length == 0) {
        $loadingTargets = grid
    } else {
        $loadingTargets = grid.closest('.modal-content')
    }

    let func = function () {
        $.ajax({
            type: "POST",
            url: __root + "Grid/BulkAct",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo(grid),
                "payload": JSON.stringify(payload),
                "magic": that.attr("data-action")
            },
            success: function (response) {
                //$modal.modal("hide")

                if (lockRenderSourceP != undefined) {
                    response.renderP = false
                }

                grid = $('#' + gridId)
                controls.onGridBeforeRender(grid, response.code, gridActions.CUSTOMONE, response.info, response.returnValue);
                controls.magic("Grid/Render", grid, response)
            },
            beforeSend: function () { loading.show($loadingTargets) },
            complete: function () { loading.hide($loadingTargets) }
        })
    }

    if (grid.hasClass('kdr-grid-lock-checkboxes')) {
        controls.lockCheckboxes(grid, func)
    }
    else {
        func()
    }
})
$(document).on('click', '.kdr-grid-custom-one-ext-w-warning', function () {
    let $btn = $(this)

    modal.getModal.warning(
        '~{Warning}',
        $btn.data('warningMessage'),
        false,
        '~{Cancel}',
        null,
        '~{Restore}',
        'btn-success',
        function ($modal) {
            let controlId = '#' + $btn.attr('control-id')

            $(controlId).one(gridEvents.BEFORE_RENDER, function (response) {
                if (response.code == gridResponseCodes.SUCCESS) {
                    toastr.success(__l.SuccessfullyRestored)
                }
            })

            $(controlId).find('.kdr-grid-custom-one').click()
            modalHelper.removeModalFromBody($modal)
        },
        $btn)
})
$(document).on("click", ".kdr-grid-add", function () {
    let that = $(this)
    let grid = that.closest(".kdr-grid")
    let gridId = grid.attr('id')
    let files = controls.getFiles(gridId)
    let item = that.closest(".kdr-grid-item-insert")

    let inputs = item.find(".kdr-grid-input")
    let args = {}
    controls.getArgs(inputs, args)

    let op = "Update"
    let actions = grid.find(".kdr-grid-save-action[data-operation-type=" + op + "]")
    let payload = []
    actions.each(function (a, b) {
        let c = $(b)
        let item = c.closest(".kdr-grid-item-update")
        //let inputs = item.children().children(".kdr-grid-input")
        let inputs = item.find(".kdr-grid-input")
        let args = {}
        controls.getArgs(inputs, args)
        payload.push(
            {
                magic: c.attr("data-action"),
                args: args
            })
    })

    let formData = new FormData();
    formData.append('info', controls.getInfo(grid))
    formData.append('magic', that.attr("data-action"))
    formData.append('args', JSON.stringify(args))
    formData.append('payload', JSON.stringify(payload))
    if (controls.appendFilesToFormData(formData, files, grid) === false) {
        return false
    }


    let $loadingTargets = null
    if (grid.closest('.modal').length == 0) {
        $loadingTargets = grid
    } else {
        $loadingTargets = grid.closest('.modal-content')
    }

    $.ajax({
        type: "POST",
        url: __root + "Grid/Act",
        datatype: "json",
        traditional: true,
        contentType: false,
        processData: false,
        //data: {
        //    "info": controls.getInfo(grid),
        //    "magic": that.attr("data-action"),
        //    "args": JSON.stringify(args),
        //    "files": files
        //},
        data: formData,
        success: function (response) {
            controls.onGridBeforeRender(grid, response.code, gridActions.ADD, response.info, response.returnValue);
            loading.hide($loadingTargets)
            controls.magic("Grid/Render", grid, response, $loadingTargets);
            //controls.onGridAfterRender(grid, response.code, gridActions.ADD);
        },
        beforeSend: function () { loading.show($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.attr('disabled', 'disabled') },
        complete: function () { loading.hide($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.removeAttr('disabled') }
    })
})

$(document).on('click', '.kdr-grid-item-insert-show', function () {
    let $this = $(this)
    let $gkv = $this.closest('.kdr-grid-key-value')
    $gkv.find('.kdr-grid-item-select').addClass('hide')
    $gkv.find('.kdr-grid-item-insert').removeClass('hide')
})

$(document).on('click', '.kdr-grid-item-update-show', function () {
    let $this = $(this)
    let $gkv = $this.closest('.kdr-grid-key-value')
    $gkv.find('.kdr-grid-item-select').removeClass('hide')
    $gkv.find('.kdr-grid-item-insert').addClass('hide')
})

$(document).on("click", ".kdr-grid-save-all", function () {
    //deb('save-all') 
    let that = $(this)
    let grid = that.closest(".kdr-grid")
    let gridId = grid.attr('id')
    let files = controls.getMultipleFiles(gridId)
    let op = that.attr("data-operation-type")
    let actions = $(grid).find(".kdr-grid-save-action[data-operation-type=" + op + "]")
    let payload = []
    actions.each(function (a, b) {
        let c = $(b)
        let item = c.closest(".kdr-grid-item-update")
        //let inputs = item.children().children(".kdr-grid-input")
        let inputs = item.find(".kdr-grid-input")
        let args = {}
        controls.getArgs(inputs, args)
        payload.push(
            {
                magic: c.attr("data-action"),
                args: args
            })
    })

    let showLoading = () => { }

    let $loadingTarget;

    if (!grid.hasClass('not-loadable-on-save-all')) {
        $loadingTarget = grid.closest('.modal').length == 0 ? grid : grid.closest('.modal .modal-content')
        showLoading = () => {
            loading.show($loadingTarget)
        }
    }

    let func2 = function (callback) {
        if (grid.hasClass('kdr-grid-lock-checkboxes')) {
            controls.lockCheckboxes(grid, callback)
        }
        else {
            callback && callback()
        }
    }

    let func = function () {
        let formData = new FormData();
        formData.append('info', controls.getInfo(grid))
        formData.append('magic', that.attr("data-action"))
        formData.append('payload', JSON.stringify(payload))
        if (controls.appendFilesToFormData(formData, files, grid, true, true) === false) {
            return false
        }

        $.ajax({
            type: "POST",
            url: __root + "Grid/BulkAct",
            datatype: "json",
            traditional: true,
            contentType: false,
            processData: false,
            data: formData,
            success: function (response) {
                controls.onGridBeforeRender(grid, response.code, gridActions.UPDATE, response.info, response.returnValue);
                controls.magic("Grid/Render", grid, response)
            },
            beforeSend: function () { showLoading() },
            complete: function () { loading.hide($loadingTarget) }
        })
    }

    func2(func)
})

$(document).on("change", ".kdr-grid-checkbox-list", function () {
    let $this = $(this)
    let checkedP = $this.valExtended()
    let colIndex = parseInt($this.data("index")) //+ (rowNumberP ? 1 : 0)
    //let gridItemsCount = parseInt($this.closest('.kdr-grid').find('.items-count-value').data('value'))
    let $allCheckboxesCB = $this.closest('.kdr-grid').find('.kdr-grid-lock-all-checkboxes[data-index="' + colIndex + '"]')
    let maxItemsToCount = parseInt($allCheckboxesCB.closest('.check-all-column').find('.kdr-grid-lock-checkboxes-max-count').val())

    let $span = $this.closest(".kdr-grid").find(".kdr-grid-footer td[data-index='" + colIndex + "'] .kdr-grid-numeric")
    //let $span = $this.closest(".kdr-grid").find('.kdr-grid-footer td[data-index="' + colIndex + '"] .kdr-grid-toggle-checkbox-filter')
    let number = parseInt($span.text())
    number += checkedP ? 1 : -1
    $span.text(number)

    //tutaj ma robic tego gornego?

    $allCheckboxesCB.valExtended(number === maxItemsToCount)
})

$(document).on("change", ".kdr-grid-lock-all-checkboxes", function () {
    //deb('save-all') 
    let $checkbox = $(this)
    let $grid = $checkbox.closest(".kdr-grid")
    //let payload = $grid.find(".kdr-grid-item-update .kdr-grid-checkbox-list").map((a, b) => { return { columnIndex: $(b).data("index"), state: $(b).valExtended(), magic: $(b).closest("tr").find(".kdr-grid-checkbox-list-action").data("action") } })
    let uncheckOtherColumnsP = $grid.hasClass('kdr-grid-lock-all-checkboxes-uncheck-other-columns')

    let formData = new FormData();
    let colIndex = $checkbox.data("index")
    let checkedP = $checkbox.valExtended()

    formData.append('info', controls.getInfo($grid))
    formData.append('checkedP', checkedP)
    formData.append('index', colIndex)
    formData.append('uncheckOtherColumnsP', uncheckOtherColumnsP)

    $.ajax({
        type: "POST",
        url: __root + "Grid/LockAllCheckboxes",
        datatype: "json",
        traditional: true,
        contentType: false,
        processData: false,
        data: formData,
        success: function (response) {
            /*controls.onGridBeforeRender(grid, response.code, gridActions., response.info, response.returnValue)*/
            controls.setInfo($grid, response.info)

            controls.magic("Grid/Render", $grid, response, undefined, undefined, undefined,
                ($g) => {
                    controls.onGridAfterCheckAllCheckboxes($g, colIndex, checkedP)
                })
        },
        beforeSend: function () { loading.show($grid) },
        complete: function () { loading.hide($grid) }
    })
})

$(document).on("click", ".tilemenu-row-header", function () {

    if ($(this).closest('.filter-tilemenu-toggle').length > 0) {

        let $control = $(this).closest('.kdr-filters');
        let $info = controls.getInfo($control);

        $.ajax({
            type: "POST",
            url: __root + "Filters/FilterOpenned",
            datatype: "json",
            traditional: true,
            data: {
                "filters": $info
            },
            success: function (response) {
                controls.setInfo($control, response.info)
            }
        })
    }
})

$(document).on("click", ".kdr-grid-s", function () {
    let $that = $(this)
    let $grid = $that.closest(".kdr-grid")

    let args = {}
    args[$that.data('index')] = $that.data('value')

    $.ajax({
        type: "POST",
        url: __root + "Filters/Change",
        datatype: "json",
        traditional: true,
        data: {
            "info": controls.getInfo($grid),
            "args": JSON.stringify(args)
        },
        success: function (response) {

            if (3 != response.code) {
                controls.setInfo($grid, response.info)
                controls.invokeCommands($grid)
                controls.magic("Grid/Render", $grid, response, $grid, false, true)
            }
        }
    })
})


//FRAX FILTER
$(document).on("click", ".kdr-frax--container-content", function (e) {
    e.stopPropagation()
})

$(document).on("click", ".kdr-grid-gridSettings", function () {
    let $settingsButton = $(this)
    let controlId = $settingsButton.data('control-id')//.closest('.kdr-grid-export').find('.kdr-grid-export-info').val()

    let $grid = controls.getControl(controlId)
    var body = $("body");
    let gridId = $grid.attr('id');

    let modalId = gridId + "-user-columns"
    var $modal = body.find("#" + modalId).clone().detach()
    $modal.attr('id', modalId + 'copied')

    userColumns.init($modal, $grid)

    modalHelper.addModalToBody($modal, $settingsButton)

    $modal.on('hidden.bs.modal', function () {
        modalHelper.removeModalFromBody($(this))
    })
})

$(document).on("click", ".kdr-grid-export-link", function () {
    let that = $(this);

    modalHelper.getModal('Grid/GridExportModal', { filename: that.attr('data-file-name') }, $(this), function ($modal) {
        $modal.on('hidden.bs.modal', function (event) {
            $modal.remove()
        })

        $modal.on('click', '#grid-export-button-modal', function () {
            //let gridExport = that.closest(".kdr-grid-export");
            let gridId = that.data('controlId')// $(gridExport).find('.kdr-grid-export-info').eq(0).val();

            let grid = $('#' + gridId)
            let $loadingTarget = /*[gridExport, */$modal.find('.modal-content')/*]*/

            /*pobieranie mnie filtrujacych filtrow do exportu*/
            let infoFilters = []
            let $filters = $('[data-control-id="' + gridId + '"]')
            let $kdrFilter = grid.find('.kdr-my-filters')

            if ($filters.length > 0) {
                $filters.each(function (index, value) {
                    infoFilters.push(controls.getInfo($(value)))
                })
            }
            else if ($kdrFilter.length > 0) {
                let ids = JSON.parse($kdrFilter.val())

                $.each(ids, (function (index, value) {
                    infoFilters.push(controls.getInfo($('#' + value)))
                }))
            }

            $.ajax({
                type: "POST",
                url: __root + "Grid/GridExport",
                datatype: "json",
                traditional: true,
                data: {
                    "info": controls.getInfo(grid),
                    "exportType": that.attr('data-action'),
                    "fileName": $modal.find('#grid-export-file-name').val(),
                    "title": that.attr('data-title'),
                    "infoFilters": infoFilters
                },
                success: function (response) {
                    if (response.code != gridResponseCodes.SUCCESS) {
                        //toastr['error'](response.message);
                        modal.getModal.danger(__l.Error, response.message, true)
                        return;
                    }

                    $modal.modal('hide')
                    let result = JSON.parse(response.args[0]);
                    let bin = atob(result.Result);
                    let bufferArray = controls.s2ab(bin);
                    let blob = new Blob([bufferArray], { type: 'application/octet-stream' })
                    controls.saveData(result.FileName, blob)
                },
                beforeSend: function () {
                    grid.trigger(gridEvents.EXPORT_START)
                    loading.show($loadingTarget)
                },
                complete: function () {
                    grid.trigger(gridEvents.EXPORT_COMPLET)
                    loading.hide($loadingTarget)
                }
            })
        })
    })
})

//external buttons for grid
$(document)//FIXME Mozna by bylo zrobic jedna funkcje dla wszystkich przyciskow
    .on('click', '.kdr-grid-remove-ext', function (e) {
        let $this = $(this)
        let controlId = $this.attr('control-id')
        let $control = controls.getControl(controlId, $this) //$this is passed for back compatiblity

        $control.find('.kdr-grid-remove').first().click()
    })
    .on('click', '.kdr-grid-add-ext', function () {
        let $this = $(this)
        let controlId = $this.attr('control-id')
        let $control = controls.getControl(controlId, $this) //$this is passed for back compatiblity

        $control.find('.kdr-grid-add').click()
    })
    .on('click', '.kdr-grid-edit-ext', function () {
        let $this = $(this)
        let controlId = $this.attr('control-id')
        let $control = controls.getControl(controlId, $this) //$this is passed for back compatiblity
        let dataRowIndex = $this.closest('[data-row-index]')?.data('rowIndex')
        let $editButton;

        $editButton = $control.find('.kdr-grid-edit, .kdr-grid-modal-edit').eq(dataRowIndex ?? 0)

        $editButton.click()

        if ($this.hasClass('not-hide') == false) {
            $($this, ' .kdr-grid-remove-ext[control-id=' + controlId + ']').hide()
            $('.kdr-grid-save-ext[control-id=' + controlId + '], .kdr-grid-cancel-ext[control-id=' + controlId + ']').show()
        }
    })
    .on('click', '.kdr-grid-save-ext', function () {
        let $this = $(this)
        let controlId = $this.attr('control-id')
        let $control = controls.getControl(controlId, $this) //$this is passed for back compatiblity
        $control.find('.kdr-grid-save').click()
        $control.find('.kdr-grid-show-spell').click()

        $control.one(gridEvents.BEFORE_RENDER, function (event) {
            if (event.code == gridResponseCodes.SUCCESS && event.actionType == gridActions.UPDATE) {
                if ($this.hasClass('not-hide') == false) {
                    $this.not('.show-only-update-view-p').hide() //save all ext
                    $('.kdr-grid-cancel-ext[control-id=' + controlId + ']').hide()
                    $('.kdr-grid-edit-ext[control-id=' + controlId + '], .kdr-grid-remove-ext[control-id=' + controlId + ']').show()
                }

                $this.trigger('grid-save-end')
            }
        })
    })
    .on('click', '.kdr-grid-cancel-ext', function () {
        let $this = $(this)
        let controlId = $this.attr('control-Id')
        let $control = controls.getControl(controlId, $this)
        $control.find('.kdr-grid-cancel').click()

        $this.hide()
        $('.kdr-grid-save-ext[control-id=' + controlId + ']').hide()
        $('.kdr-grid-edit-ext[control-id=' + controlId + '], .kdr-grid-add-ext[control-id=' + controlId + ']').show()

    })
    .on('click', '.kdr-grid-item-insert-show-ext', function () {
        let $this = $(this)
        let controlId = $this.attr('control-Id')
        let $control = controls.getControl(controlId, $this)
        $control.find('.kdr-grid-item-insert-show').click()

        $('.kdr-grid-remove-ext[control-id=' + controlId + '], .kdr-grid-add-ext[control-id=' + controlId + ']').show()
        $this.hide()

    })
    .on('click', '.kdr-grid-item-update-show-ext', function () {
        let $this = $(this)
        let controlId = $this.attr('control-Id')
        let $control = controls.getControl(controlId, $this)
        $control.find('.kdr-grid-save').click()

        $control.one(gridEvents.BEFORE_RENDER, function (event) {
            if (event.code == gridResponseCodes.SUCCESS && event.actionType == gridActions.UPDATE) {
                $('.kdr-grid-edit-ext[control-id=' + controlId + '], .kdr-grid-remove-ext[control-id=' + controlId + ']').show()
                $this.hide() //save all ext
            }
        })
    })
    .on('click', '.kdr-grid-custom-one-ext', function () {
        let gridId = $(this).attr('control-id')
        let $control = controls.getControl(gridId)
        let $loadingTargets = $('.btn[control-id=' + gridId + ']')
        loading.show($loadingTargets)

        $control.one(gridEvents.BEFORE_RENDER, function () {
            loading.hide($loadingTargets)
        })

        $control.find('.kdr-grid-custom-one').first().click()
    })
    .on('click', '.kdr-frax-remove-confirm-ext', function () {
        let fraxId = $(this).attr('control-id')
        let $frax = controls.getControl(fraxId)
        let $loadingTargets = $('.btn[control-id=' + fraxId + ']')
        loading.show($loadingTargets)

        $frax.one(gridEvents.BEFORE_RENDER, function () {
            loading.hide($loadingTargets)
        })

        let $that = $frax.find('.kdr-frax-act-remove')

        let args = { selected: $frax.find('.kdr-frax--tree').jstree().get_selected() }

        $.ajax({
            type: "POST",
            url: __root + "Frax/Act",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo($frax),
                "magic": $that.attr("data-magic"),
                "args": JSON.stringify(args)
            },
            success: function (response) {
                controls.onGridBeforeRender($frax, response.code, fraxActions.REMOVE, response.info, response.returnValue)
                controls.magic(controls.getEndpoint($frax), $frax, response, $loadingTargets);
            },
            beforeSend: function () { loading.show($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.attr('disabled', 'disabled') },
            complete: function () { loading.hide($loadingTargets); if ($loadingTargets != undefined && $loadingTargets != null) $loadingTargets.removeAttr('disabled') }
        })
    })
    .on('click', '.kdr-grid-cancel-all-ext', function () {
        let $this = $(this)
        let controlId = $this.attr('control-Id')
        let $control = controls.getControl(controlId, $this)
        let $itemsToSlide = $control.find('.kdr-grid-custom-btns > *, .pagination-wrapper, .kdr-grid-export, .kdr-grid-quick-filters')

        $control.find('.kdr-grid-cancel-all').click()

        $itemsToSlide.slideDown(150)
        $('.kdr-grid-save-all-ext[control-id=' + controlId + ']').hide()
        $('.kdr-grid-edit-all-ext[control-id=' + controlId + ']').show()
        $this.hide()
    })
    .on('click', '.kdr-grid-edit-all-ext', function () {
        let $this = $(this)
        let controlId = $this.attr('control-id')
        let $control = controls.getControl(controlId, $this)
        $control.find('.kdr-grid-edit-all').click()
        let $itemsToSlide = $control.find('.kdr-grid-custom-btns > *, .pagination-wrapper, .kdr-grid-export, .kdr-grid-quick-filters')

        $itemsToSlide.slideUp(150)
        $this.hide()
        $('.kdr-grid-save-all-ext[control-id=' + controlId + ']' + ', .kdr-grid-cancel-all-ext[control-id=' + controlId + ']').show()
    })
    .on('click', '.kdr-grid-save-all-ext', function () {
        let $this = $(this)
        let controlId = $this.attr('control-id')
        let $control = controls.getControl(controlId, $this)
        let $loadingTarget = $this.closest('.modal').length > 0 ? $this.closest('.modal-content') : $('.btn[control-id=' + controlId + ']')

        loading.show($loadingTarget)

        $control.one(gridEvents.BEFORE_RENDER, function (event) {
            loading.hide($loadingTarget)
            if (event.code == gridResponseCodes.SUCCESS && event.actionType == gridActions.UPDATE) {
                $('.kdr-grid-edit-all-ext[control-id=' + controlId + ']').show()

                if ($this.hasClass('not-hide') == false) {
                    $this.hide()
                    $('.kdr-grid-cancel-all-ext[control-id=' + controlId + ']').hide()
                }
            } else {
                $('.kdr-grid-edit-all-ext[control-id=' + controlId + ']').click()
            }

            $this.trigger('grid-save-all-end')
        })

        $control.find('.kdr-grid-save-all').first().click()
    })
    .on('click', '.kdr-grid-clear-all-inputs', function (e) {
        let controlId = $(this).attr('control-id')
        let $grid = controls.getControl(controlId)
        $grid.find('.kdr-grid-input:visible').valExtended('')
    })
    .on('click', '.kdr-grid-save-modal, .kdr-grid-add-modal', function (e) {
        let $btn = $(this)

        if ($btn.attr('disabled') == 'disabled') {
            return false
        } else {
            $btn.attr('disabled', 'disabled')
        }

        let gridAction = $btn.hasClass('kdr-grid-save-modal') ? gridActions.UPDATE : gridActions.ADD
        let $modal = $btn.closest('.modal')
        let controlId = $btn.attr('control-id')

        let $cachedGrid = $modal.data('cached-grid') //controls.getControl(controlId)
        let cachedGridInfo = $modal.data('cached-grid-info')

        let $loadingIndicator = $modal.find('.modal-content')


        let files = controls.getFiles(controlId)
        let inputs = $modal.find(".kdr-grid-input")
        let args = {}
        controls.getArgs(inputs, args)

        let formData = new FormData();
        formData.append('info', cachedGridInfo)
        formData.append('magic', $btn.attr("data-action"))
        formData.append('args', JSON.stringify(args))

        if (controls.appendFilesToFormData(formData, files, $cachedGrid) === false) {
            return false
        }

        $.ajax({
            type: "POST",
            url: __root + "Grid/Act",
            datatype: "json",
            traditional: true,
            contentType: false,
            processData: false,
            data: formData,
            success: function (response) {
                let $grid = controls.getControl(controlId)

                controls.onGridBeforeRender($grid, response.code, gridAction, response.info, response.returnValue);
                controls.magic("Grid/Render", $grid, response)

                if (response.code == gridResponseCodes.SUCCESS) {
                    modalHelper.removeModalFromBody($modal)
                }
            },
            beforeSend: function () {
                loading.show($loadingIndicator)
            },
            complete: function () {
                loading.hide($loadingIndicator)

                $btn.removeAttr('disabled')
            }
        })
    })

$(document).on('click', '.kdr-grid-perform-all-custom-ones', function () {
    let $btn = $(this)
    let $container = $($btn.data('container'))
    let $loading = $container.closest('.modal-content')
    loading.show($loading)
    let $customOnesBtns = $container.find('.kdr-grid-custom-one')

    let endedAjaxs = 0
    let successCount = 0

    for (let i = 0; i < $customOnesBtns.length; i++) {

        let $customOneBtn = $customOnesBtns.eq(i)
        let $grid = $customOneBtn.closest('.kdr-grid')
        let gridId = $grid.prop('id')

        $grid.addClass('.not-loadable')

        $grid.off(gridEvents.BEFORE_RENDER + '.PERFORM_ALL_CUSTOM_ONES')
            .on(gridEvents.BEFORE_RENDER + '.PERFORM_ALL_CUSTOM_ONES', function (response) {
                endedAjaxs++

                if (response.code == gridResponseCodes.SUCCESS) {
                    successCount++
                }

                //console.log(`Ended count: ${endedAjaxs}`)
                //console.log($grid)

                if (endedAjaxs == $customOnesBtns.length) {
                    console.log(`Ended All and performing trigger`)
                    loading.hide($loading)

                    $btn.trigger({
                        type: 'done',
                        isSuccess: endedAjaxs == successCount
                    })
                }
            })

        //console.log(`Sended: ${i}`)
        //console.log($customOneBtn)
        //console.log($grid)

        $customOneBtn.click()
    }

})

$(document).on('click', '.kdr-grid-perform-all-custom-ones-refresh', function () {
    let $btn = $(this)
    let $container = $($btn.data('container'))
    loading.show()
    let $customOnesBtns = $container.find('.kdr-grid-custom-one')


    let $control = controls.getControl($btn.attr('data-refresh-target'))

    let endedAjaxs = 0
    let successCount = 0
    $customOnesBtns.each(function (i, e) {
        let $customOneBtn = $(e)
        let $grid = $customOneBtn.closest('.kdr-grid')
        $grid.addClass('.not-loadable')

        $grid.one(gridEvents.BEFORE_RENDER, function (response) {
            endedAjaxs++
            if (response.code == gridResponseCodes.SUCCESS) {
                successCount++
            }

            if (endedAjaxs == $customOnesBtns.length/* - 1*/) {
                loading.hide()

                if ($control.length > 1) {
                    $control.each(function (i, e) {
                        controls.refresh($(e), null, null, null)
                    })
                }
                else {
                    controls.refresh($control, null, null, null)
                }

                //$btn.trigger('done')
                $btn.trigger({
                    type: 'done',
                    isSuccess: endedAjaxs == successCount
                })
            }
        })

        $customOneBtn.click()
    })
})

$(document).on('click', '.kdr-grid-perform-all-save-all-ext', function () {
    let $btn = $(this)
    let $container = $($btn.data('container'))
    loading.show()
    let $customOnesBtns = $container.find('.kdr-grid-save-all')

    let endedAjaxs = 0
    let successCount = 0
    $customOnesBtns.each(function (i, e) {
        let $customOneBtn = $(e)
        let $grid = $customOneBtn.closest('.kdr-grid')
        $grid.addClass('.not-loadable')

        $grid.one(gridEvents.BEFORE_RENDER, function (response) {
            endedAjaxs++
            if (response.code == gridResponseCodes.SUCCESS) {
                successCount++
            }

            if (endedAjaxs == $customOnesBtns.length/* - 1*/) {
                loading.hide()
                //$btn.trigger('done')
                $btn.trigger({
                    type: 'done',
                    isSuccess: endedAjaxs == successCount
                })
            }
        })

        $customOneBtn.click()
    })
})

$(document).on('click', '.kdr-grid-perform-total-all-save-all-ext', function () {
    let $btn = $(this)
    let $container = $btn.closest('.modal-content')
    loading.show()
    let $saveOnesBtns = $container.find('.kdr-grid-save-all, .kdr-grid-save')

    let endedAjaxs = 0
    let successCount = 0
    $saveOnesBtns.each(function (i, e) {
        let $saveOneBtn = $(e)
        let $grid = $saveOneBtn.closest('.kdr-grid')
        $grid.addClass('.not-loadable')

        $grid.one(gridEvents.BEFORE_RENDER, function (response) {
            endedAjaxs++
            if (response.code == gridResponseCodes.SUCCESS) {
                successCount++
            }

            if (endedAjaxs == $saveOnesBtns.length/* - 1*/) {
                loading.hide()
                //$btn.trigger('done')
                $btn.trigger({
                    type: 'all-grid-are-saved',
                    isSuccess: endedAjaxs == successCount
                })
            }
        })

        $saveOneBtn.click()
    })
})

$(document).on('click', '.kdr-grid-perform-sequence-save-all-ext', function () {
    let $btn = $(this)
    let $container = $btn.closest('.modal-content')
    loading.show()
    let $saveOnesBtns = $container.find('.kdr-grid-save-all, .kdr-grid-save')

    function saveSequentially(index = 0) {
        if (index == $saveOnesBtns.length) {
            loading.hide()

            $btn.trigger({
                type: 'all-grid-are-saved',
                isSuccess: true
            })
        }

        let $saveOneBtn = $($saveOnesBtns[index])
        let $grid = $saveOneBtn.closest('.kdr-grid')
        $grid.addClass('.not-loadable')

        $grid.one(gridEvents.BEFORE_RENDER, function (response) {
            if (response.code == gridResponseCodes.SUCCESS) {
                saveSequentially(index + 1)
            }
            else {
                loading.hide()
            }
        })

        $saveOneBtn.click()
    }

    saveSequentially()
})

$(document).on('change', '.kdr-grid-files-picker .grid-file-input', function () {
    controls.renderSelectedItems($(this))
})

$(document).on("click", ".kdr-grid-files-remove", function () {
    let $this = $(this)
    let $fileContainer = $this.closest('.kdr-grid-files-file')
    let key = $fileContainer.find('.file-id').val()
    let $input = $this.closest('.kdr-grid-files').find('.grid-file-input')
    let selectedFiles = $input.data('selectedFiles')

    let droppedFiles = selectedFiles.filter(function (item) {
        return item.id != key;
    });

    $input.data('selectedFiles', droppedFiles)
    $fileContainer.remove()
    controls.renderSelectedItems($input)
})

$(document).on("click", ".kdr-grid-table .kdr-grid-edit, .kdr-grid-table .kdr-grid-cancel", function () {
    controls.recalculateGridTableHeaderOffets($(this).closest('.kdr-grid'))
})


$(document).on('click', '.kdr-grid-toggle-fullscreen', function () {
    let $btn = $(this)
    let $grid = controls.getControl(null, $btn)
    controls.grid.toggleGridFullscreen($grid)
})

$(document).on('click', '.kdr-grid-toggle-textareas', function () {
    let $btn = $(this)
    let $grid = controls.getControl(null, $btn)
    let newStateP = !convert.stringToBoolean($btn.attr('data-state'))

    controls.grid.toggleTextareas($grid, newStateP, $btn)

    $btn.attr('data-state', newStateP)
    //toastr.success('state ' + newStateP)
})

$(document).on('click', '.kdr-grid-toggle-width', function () {
    let $btn = $(this)
    let $parent = $btn.closest('.comprasion-of-results-resizer-layout')

    $parent.toggleClass('expanded')
    
})

$(document).on('click', '.kdr-grid-fullscreen', function (e) {
    if ($(e.target).hasClass('kdr-grid-fullscreen')) {
        controls.grid.toggleGridFullscreen($(this))
    }
})

const _refreshSubrowsEvent = 'kdr-refresh-subrow-group'
const _rowsStateDataAttr = 'data-subrows-are-visible'

$(document).on('click', '.subrows-container .toggle-subrows', function () {
    let $btn = $(this)
    let $row = $btn.closest('.subrow-toggling-container')
    let subRowId = $row.data('subrowId')
    let rowsAreHiddenP = !(convert.stringToBoolean($btn.attr(_rowsStateDataAttr)) ?? true)

    //$(`.kdr-grid-item-select[data-hook-id="${subRowId}"]`).attr('data-hidden-row-p', rowsAreHiddenP.toString().toLowerCase())

    ///sync state with hidden toggler with same id, eg. kdr-grid-item-select/update,
    $(`[data-subrow-id="${subRowId}"] .toggle-subrows`).attr(_rowsStateDataAttr, rowsAreHiddenP)

    //$btn.find('.toggle-subsrows-icon').toggle()
    $row.closest('.subrows-container').find('.toggle-subrows').each((i, e) => $(e).trigger(_refreshSubrowsEvent))
})

$(document).on(_refreshSubrowsEvent, '.subrows-container .toggle-subrows', function () {
    let $toggler = $(this)
    let $row = $toggler.closest('.subrow-toggling-container')
    let hookId = $row.data('hookId')
    let hookState = $(`[data-subrow-id="${hookId}"]`).length != 0 ? $(`[data-subrow-id="${hookId}"]`).is(':visible') : true


    if (hookState === true) {
        let togglerState = false
        let rowsState = convert.stringToBoolean($toggler.attr(_rowsStateDataAttr))
        let thisSubrowid = $row.attr('data-subrow-id')

        ///sync state with hidden toggler with same id, eg. kdr-grid-item-select/update,
        $(`[data-subrow-id="${thisSubrowid}"] .toggle-subrows`).each((i, e) => {
            togglerState = !!(togglerState | $(e).is(':visible'))
        })


        let subRowId = $toggler.closest('.subrow-toggling-container').data('subrowId')
        let $rows = $(`.subrow-toggling-container[data-hook-id="${subRowId}"]`)

        if (togglerState === true && rowsState === true) {
            $rows.attr('data-hidden-row-p', false)
        } else if (togglerState === false && rowsState === true) {
            $rows.attr('data-hidden-row-p', true)
        } else if (togglerState === true && rowsState == false) {
            $rows.attr('data-hidden-row-p', true)
        } else if (togglerState === false && rowsState == false) {
            $rows.attr('data-hidden-row-p', true)
        }
    } else {
        let subRowId = $toggler.closest('.subrow-toggling-container').data('subrowId')
        $(`.subrow-toggling-container[data-hook-id="${subRowId}"]`).attr('data-hidden-row-p', true)
        $(`.subrow-toggling-container[data-subrow-id="${subRowId}"]`).attr('data-hidden-row-p', true)
    }
})

$(document).on('input', '.kdr-grid-input.count-characters', function () {
    textHelper.countCharactersAndDisplay($(this))
})

$(document).on(gridEvents.AFTER_RENDER_IMMEDIATELY, '.kdr-grid', function (e) {
    e.stopPropagation()

    let $grid = $(this)
    controls.grid.initUI($grid)
})
$(document).on('click', '.kdr-grid-generic-modal:not([data-href=""]):not([disabled="disabled"]):not(.not-modal-just-normal-link):not(.not-modal-just-normal-button, .new-grid-not-modal-just-normal-link)', function () {
    let $btn = $(this)

    modalHelper.getModal($btn.data('href'), { p: $btn.data('p') }, $btn)
})
$(document).on('mousedown', '.kdr-grid-generic-modal.not-modal-just-normal-link:not([data-href=""]):not([disabled="disabled"])', function (e) {
    let $btn = $(this)
    if ($btn.attr('href').includes('#')) {
        let realLink = `${__root}${$btn.data('href')}?p=${$btn.data('p')}`
        $btn.attr('href', realLink)
    }   
})
$(document).on('click', '.kdr-grid-generic-download:not([data-href=""]):not([disabled="disabled"]):not(.kdr-grid-generic-modal)', function () {
    let $btn = $(this)
    window.open(`${__root + $btn.data("href")}?p=${$btn.data("p")}`, "_top")
})

$(document).on('click', '.kdr-grid-generic-action:not([data-href=""]):not([disabled="disabled"]):not(.kdr-grid-generic-modal):not(.kdr-grid-generic-download)', function () {
    let $btn = $(this)
    $.ajax({
        type: "POST",
        url: __root + $btn.data("href"),
        datatype: "json",
        traditional: true,
        data: {
            "p": $btn.data("p")
        },
        success: function (response) {
            if (response != undefined && response.code != undefined) {
                toastr[toastrTypes[response.code]](response.message)
            }
        },
        error: function (r) {
            toastr.error(r.statusText, r.status)
        },
        beforeSend: function () {
            loading.show($btn)
        },
        complete: function () {
            loading.hide($btn)
        }
    });
})

var userColumns = {
    init($ucModal, $grid) {
        $ucModal.on('shown.bs.modal', function () {
            $(this).find('#kdr-grid-user-columns-manager-sortable').sortable()
            $(this).find('.user-column-container').find('.user-column-is-active, .user-column-radio, label.btn, label.custom-control-label, .user-column[data-cb-selector-id]').each(function () {
                let $item = $(this)

                if ($item.is('input') || $item.hasClass('custom-control-input') || $item.hasClass('user-column-radio')) {
                    $item.prop('id', $item.prop('id') + 'cp')
                    $item.prop('name', $item.prop('name') + 'cp')
                } else if ($item.hasClass('user-column')) {
                    $item.data('cbSelectorId', $item.data('cbSelectorId') + 'cp')
                } else {
                    $item.attr('for', $item.attr('for') + 'cp')
                }
            })
        })
        $ucModal.find('.user-column-radio').on('change', function () {
            let $radio = $(this)
            let $radioGroup = $(`[name="${$radio.prop('name')}"]`)
            $radioGroup.each((i, e) => {
                let $r = $(e)
                let $button = $r.parent()
                if ($r.is(':checked')) {
                    $button.addClass('btn-primary')
                    $button.removeClass('btn-default')
                } else {
                    $button.removeClass('btn-primary')
                    $button.addClass('btn-default')
                }
            })
        })
        $ucModal.find('.kdr-grid-set-user-columns, .kdr-grid-restore-user-columns').click(function () {
            let $btn = $(this)
            let $modalContent = $btn.closest('.modal-content')
            let $userColumnContainersParent = $modalContent.find('.kdr-grid-user-columns-manager')
            let isProfileActive = $btn.hasClass('kdr-grid-set-user-columns')
            function _callback(response) {
                $grid.trigger({
                    type: 'KDR_GRID_GRIDSETTINGS_AC',
                    code: response.code
                });

                if (response.code == gridResponseCodes.SUCCESS) {
                    setTimeout(() => controls.refresh($grid), 0)
                    modalHelper.removeModalFromBody($ucModal)
                }
            }

            userColumns.saveColumns($grid, userColumns.getColumns($userColumnContainersParent), isProfileActive, $modalContent, _callback)
        })
    },
    getColumns($userColumnContainersParent) {
        function _getNewColumnList($mainContainer) {
            let isContainerVisible = $mainContainer.is(':visible')

            function __getSnap($container) {
                let val = $container.find('.column-lock-selector:first label.active .user-column-radio').valExtended()
                return val
            }
            function __getColumnHeaderWidth(columnMagic) {
                if (isContainerVisible) {
                    let widthFromInput = $mainContainer.find(`[data-column-magic="${columnMagic}"] .user-column-width-input`).val()
                    return parseInt(widthFromInput)
                } else {
                    let $th = $(`th[data-column-magic="${textHelper.escapeCharacters(columnMagic)}"]`)
                    let style = $th.attr('style')
                    let settedWidthP = style && style.includes('width') && style.includes('min-width')
                    if (settedWidthP === false) {
                        return null
                    } else {
                        return parseInt($th.css('width'))
                    }
                }
            }
            function __addColumn(columnName, isActive, snap, columnHeaderWidth) {
                columns.push({
                    columnName: columnName,
                    isActive: isActive,
                    snap: snap,
                    columnHeaderWidth: columnHeaderWidth
                })
            }

            let columns = []

            $mainContainer.find('.user-column-container').each((i, e) => {
                let $container = $(e)
                let $mainColumnContainer = $container.find('.user-column')
                let isActiveMainColumn = $(`#${$mainColumnContainer.data('cbSelectorId')}`).valExtended()
                let columnName = $mainColumnContainer.prop('id')
                let columnMagic = $mainColumnContainer.data('columnMagic')


                __addColumn(columnName, isActiveMainColumn, __getSnap($container), __getColumnHeaderWidth(columnMagic))

                $container.find('.user-subcolumn').each((j, f) => {
                    let $subcolumn = $(f)
                    let subcolumnMagic = $subcolumn.data('columnMagic')

                    __addColumn($subcolumn.prop('id'), isActiveMainColumn, __getSnap($subcolumn), __getColumnHeaderWidth(subcolumnMagic))
                })
            })

            return columns
        }

        return _getNewColumnList($userColumnContainersParent)
    },
    saveColumnsInGrid($grid, $loadingIndicator, _callback) {
        let gridId = $grid.prop('id')
        let $ucModal = $(`#${gridId}-user-columns`)
        let $userColumnContainersParent = $ucModal.find('.kdr-grid-user-columns-manager')
        let isProfileActive = $ucModal.find('.kdr-grid-set-user-columns').length != 0
        let columns = userColumns.getColumns($userColumnContainersParent)

        let secondLayerCallback = function (response) {
            if (response.code == gridResponseCodes.SUCCESS) {
                for (var i = 0; i < columns.length; i++) {
                    let col = columns[i]
                    $userColumnContainersParent.find(`#${col.columnName} .user-column-width-input`).val(col.columnHeaderWidth)
                }
            }

            _callback && _callback(response)
        }


        userColumns.saveColumns($grid, columns, isProfileActive, $loadingIndicator, secondLayerCallback)
    },
    saveColumns($grid, columns, isProfileActive, $loadingIndicator, callback) {
        $.ajax({
            type: "POST",
            url: __root + "Grid/SetUserColumns",
            datatype: "json",
            traditional: true,
            data: {
                info: controls.getInfo($grid),
                columns: JSON.stringify(columns),
                IsActive: isProfileActive,
            },
            success: function (response) {
                callback && callback(response)

                if (response.code != gridResponseCodes.SUCCESS) {
                    modal.getModalAjax({
                        type: response.code,
                        title: __l.Error,
                        message: response.message,
                        isCloseButton: true
                    })
                }
            },
            beforeSend: () => $loadingIndicator && loading.show($loadingIndicator),
            complete: () => $loadingIndicator && loading.hide($loadingIndicator)
        })
    }
}

function ReplaceEditRow(index, controlId) {
    let $grid = controls.getControl(controlId)
    let modalId = "grid-edit-modal-" + controlId
    var $body = $grid.find("#edit-container-" + index);
    var $footer = $grid.find("#footer-container-" + index);

    var $modalBody = $grid.find("#grid-modal-edit-container");
    var $modalFooter = $grid.find("#grid-modal-footer-container");

    $modalBody.html($body.html());
    $modalFooter.html($footer.html());

    let $clonedModal = $('#' + modalId).clone().appendTo('body')
    $clonedModal.attr('id', 'copied-' + modalId)

    $clonedModal.data('cached-grid', $grid)
        .data('cached-grid-info', controls.getInfo($grid))

    $clonedModal.find('.kdr-dropdown-w-search-item_selected').each((i, e) => {
        let $btn = $(e)
        let oldDdlId = $btn.data('target')
        let newDdlId = 'cp' + oldDdlId
        $btn.data('target', newDdlId).attr('data-target', newDdlId)

        $('#' + oldDdlId).clone().attr('id', newDdlId).appendTo($clonedModal.find('.modal-content'))

        $clonedModal.find('#' + oldDdlId).remove()
    })



    $clonedModal.find('.custom-control .custom-control-input').each(function (i, e) { $(e).attr('id', 'cp' + $(e).attr('id')) }) //fixme uwspolnic
    $clonedModal.find('.custom-control .custom-control-label').each(function (i, e) { $(e).attr('for', 'cp' + $(e).attr('for')) })
    $clonedModal.find('.kdr-grid-files-input').each((i, e) => { $(e).attr('id', 'cp' + $(e).attr('id')) })
    $clonedModal.find('.kdr-grid-files-input-label').each((i, e) => { $(e).attr('for', 'cp' + $(e).attr('for')) })
    $clonedModal.find('[id^="kdr-grid-editor-"]').each((i, e) => { $(e).attr('id', 'cp' + $(e).attr('id')) })

    $clonedModal.find('[class*="ds-"], [class*="dt-"], [class*="da-"]')
        .each((i, e) => {
            let $e = $(e)
            let cls = $($e[0].classList)
            cls.each((ii, ee) => {
                if (/ds-/i.test(ee) || /dt-/i.test(ee) || /da-/i.test(ee)) {
                    cls[ii] = ee + "cp"
                }
            })
            let c = Array.from(cls).join(" ")
            $e.prop("class", c)
        })
        .trigger(disabler.events.disabler)

    $clonedModal.data('row-id', index)

    pickers.init($clonedModal)
    controls.prepareTinyMCE($clonedModal)

    modal.prepareModal('copied-' + modalId, undefined, undefined, controlId)

}

function ReplaceDisplayedEditRow(index, controlId) {
    let $grid = controls.getControl(controlId)
    let modalId = "grid-edit-modal-" + controlId
    var $body = $grid.find("#edit-container-" + index);
    var $footer = $grid.find("#footer-container-" + index);

    var $modalBody = $grid.find("#grid-modal-edit-container");
    var $modalFooter = $grid.find("#grid-modal-footer-container");

    $modalBody.html($body.html());
    $modalFooter.html($footer.html());

    let $m = $('#' + modalId)
    let $oldClonedModal = $('#copied-' + modalId)

    $oldClonedModal.html($m.html())

    $oldClonedModal.data('cached-grid', $grid)
        .data('cached-grid-info', controls.getInfo($grid))

    $oldClonedModal.find('.kdr-dropdown-w-search-item_selected').each((i, e) => {
        let $btn = $(e)
        let oldDdlId = $btn.data('target')
        let newDdlId = 'cp' + oldDdlId
        $btn.data('target', newDdlId).attr('data-target', newDdlId)

        $('#' + oldDdlId).clone().attr('id', newDdlId).appendTo($oldClonedModal.find('.modal-content'))

        $oldClonedModal.find('#' + oldDdlId).remove()
    })

    $oldClonedModal.find('.custom-control .custom-control-input').each(function (i, e) { $(e).attr('id', 'cp' + $(e).attr('id')) }) //fixme uwspolnic
    $oldClonedModal.find('.custom-control .custom-control-label').each(function (i, e) { $(e).attr('for', 'cp' + $(e).attr('for')) })
    $oldClonedModal.find('.kdr-grid-files-input').each((i, e) => { $(e).attr('id', 'cp' + $(e).attr('id')) })
    $oldClonedModal.find('.kdr-grid-files-input-label').each((i, e) => { $(e).attr('for', 'cp' + $(e).attr('for')) })
    $oldClonedModal.find('[id^="kdr-grid-editor-"]').each((i, e) => { $(e).attr('id', 'cp' + $(e).attr('id')) })

    $oldClonedModal.find('[class*="ds-"], [class*="dt-"], [class*="da-"]')
        .each((i, e) => {
            let $e = $(e)
            let cls = $($e[0].classList)
            cls.each((ii, ee) => {
                if (/ds-/i.test(ee) || /dt-/i.test(ee) || /da-/i.test(ee)) {
                    cls[ii] = ee + "cp"
                }
            })
            let c = Array.from(cls).join(" ")
            $e.prop("class", c)
        })
        .trigger(disabler.events.disabler)


    $oldClonedModal.data('row-id', index)
    $oldClonedModal.attr('for', controlId)

    pickers.init($oldClonedModal)
    controls.prepareTinyMCE($oldClonedModal)
}

function ReplaceInsertRow(controlId) {
    let $modal = $('#' + 'add-modal-' + controlId)

    let $clonedModal = $modal.clone().appendTo('body')
    let newId = 'copied-grid-add-modal-' + controlId
    $clonedModal.attr('id', newId)

    let $grid = controls.getControl(controlId)
    $clonedModal.data('cached-grid', $grid)
        .data('cached-grid-info', controls.getInfo($grid))

    $clonedModal.find('.kdr-dropdown-w-search-item_selected').each((i, e) => {
        let $btn = $(e)
        let oldDdlId = $btn.data('target')
        let newDdlId = 'cp' + oldDdlId
        $btn.data('target', newDdlId).attr('data-target', newDdlId)

        $('#' + oldDdlId).clone().attr('id', newDdlId).appendTo($clonedModal.find('.modal-content'))

        $clonedModal.find('#' + oldDdlId).remove()
    })

    $clonedModal.find('.custom-control .custom-control-input').each(function (i, e) { $(e).attr('id', 'cp' + $(e).attr('id')) }) //fixme uwspolnic
    $clonedModal.find('.custom-control .custom-control-label').each(function (i, e) { $(e).attr('for', 'cp' + $(e).attr('for')) })
    $clonedModal.find('.kdr-grid-files-input').each((i, e) => { $(e).attr('id', 'cp' + $(e).attr('id')) })
    $clonedModal.find('.kdr-grid-files-input-label').each((i, e) => { $(e).attr('for', 'cp' + $(e).attr('for')) })
    $clonedModal.find('[id^="kdr-grid-editor-"]').each((i, e) => { $(e).attr('id', 'cp' + $(e).attr('id')) })

    $clonedModal.find('[class*="ds-"], [class*="dt-"], [class*="da-"]')
        .each((i, e) => {
            let $e = $(e)
            let cls = $($e[0].classList)
            cls.each((ii, ee) => {
                if (/ds-/i.test(ee) || /dt-/i.test(ee) || /da-/i.test(ee)) {
                    cls[ii] = ee + "cp"
                }
            })
            let c = Array.from(cls).join(" ")
            $e.prop("class", c)
        })
        .trigger(disabler.events.disabler)



    pickers.init($clonedModal)
    controls.prepareTinyMCE($clonedModal)

    modal.prepareModal(newId, undefined, undefined, controlId)
}

function ReplaceDisplayedInsertRow(controlId) {
    let $modal = $('#' + 'add-modal-' + controlId)
    let modalId = $modal.attr('id')
    let $oldClonedModal = $('#copied-grid-' + modalId)

    $oldClonedModal.html($modal.html())

    let $grid = controls.getControl(controlId)
    $oldClonedModal.data('cached-grid', $grid)
        .data('cached-grid-info', controls.getInfo($grid))

    $oldClonedModal.find('.kdr-dropdown-w-search-item_selected').each((i, e) => {
        let $btn = $(e)
        let oldDdlId = $btn.data('target')
        let newDdlId = 'cp' + oldDdlId
        $btn.data('target', newDdlId).attr('data-target', newDdlId)

        $('#' + oldDdlId).clone().attr('id', newDdlId).appendTo($oldClonedModal.find('.modal-content'))
        $oldClonedModal.find('#' + oldDdlId).remove()

    })


    $oldClonedModal.find('.custom-control .custom-control-input').each(function (i, e) { $(e).attr('id', 'cp' + $(e).attr('id')) }) //fixme uwspolnic
    $oldClonedModal.find('.custom-control .custom-control-label').each(function (i, e) { $(e).attr('for', 'cp' + $(e).attr('for')) })
    $oldClonedModal.find('.kdr-grid-files-input').each((i, e) => { $(e).attr('id', 'cp' + $(e).attr('id')) })
    $oldClonedModal.find('.kdr-grid-files-input-label').each((i, e) => { $(e).attr('for', 'cp' + $(e).attr('for')) })
    $oldClonedModal.find('[id^="kdr-grid-editor-"]').each((i, e) => { $(e).attr('id', 'cp' + $(e).attr('id')) })

    $oldClonedModal.find('[class*="ds-"], [class*="dt-"], [class*="da-"]')
        .each((i, e) => {
            let $e = $(e)
            let cls = $($e[0].classList)
            cls.each((ii, ee) => {
                if (/ds-/i.test(ee) || /dt-/i.test(ee) || /da-/i.test(ee)) {
                    cls[ii] = ee + "cp"
                }
            })
            let c = Array.from(cls).join(" ")
            $e.prop("class", c)
        })
        .trigger(disabler.events.disabler)


    $oldClonedModal.attr('for', controlId)

    pickers.init($oldClonedModal)
    controls.prepareTinyMCE($oldClonedModal)
    //modal.prepareModal(modalId, undefined, undefined, controlId)
}

$(document).on('click', '.modal[id^="copied"] [data-dismiss="modal"]', function (e) {
    e.preventDefault()
    e.stopPropagation()
    $(this).closest('.modal').modal('hide')
    $(this).closest('.modal').remove()
})

$(document).on('click', '.on-click-select', function (e) {
    $(this).closest('tr').find('.kdr-grid-s').click()
})

$(document).on('click', '.on-input-save-click', function () {
    $(this).closest('tr').find('.kdr-grid-save').click()
})

$(document).on('change', '.on-input-change-save-all', function () {
    $(this).closest('.kdr-grid').find('.kdr-grid-save-all').click()
})

$(document).on('change', '.on-input-change-custom-one', function () {
    $(this).closest('.kdr-grid').find('.kdr-grid-custom-one').click()
})

$(document).on('change', '.on-input-change-save', function () {
    $(this).closest('.kdr-grid').find('.kdr-grid-save').click()
})

$(document).on('click', '.on-input-save-click-ab', function () {
    $(this).closest('.kdr-grid').find('.kdr-grid-save').click()
})

$(document).on('click', '.on-input-save-click', function () {
    $(this).closest('tr').find('.kdr-grid-save').click()
})

$(document).on('click', '.get-insert-modal', function () {
    let $btn = $(this)
    let endPoint = $btn.data('link')
    let $control = $btn.closest(".kdr-control")
    let gridId = $control.attr("id")
    let $modal = $btn.closest('.modal')

    if (gridId == undefined && $modal.length > 0) {
        let modalId = $modal.attr('id')
        let regexPattern = /(^copied-[^\s]*-modal-)/i

        if (regexPattern.test(modalId)) {
            gridId = modalId.replace(regexPattern, '')
        }
    }

    if ($control == null || $control.length == 0) {
        $control = $('#' + gridId)
    }

    if ($control.length == 0 && gridId.length == 0) {
        throw console.error("DDL+ .get-insert-modal: Grid - not found")
    }

    let data = null
    if ($btn.data("withInfoP") === true) {
        data = { info: controls.getInfo($btn.closest(".kdr-filters")) }
    }
    let $loadingIndicator = $btn.closest('.modal').find('.modal-content')

    let $ddl = $btn.closest('.kdr-dropdown-w-search-menu')
    let $btnToggler = $ddl.data().toggler ?? $ddl.find('.kdr-dropdown-w-search-item_selected')
    let btnTogglerP = $btnToggler != undefined && $btnToggler.length == 1
    let $btnTDParent = true === btnTogglerP ? $btnToggler.closest('td') : $btn.closest("td");
    let $btnTDOrdinalParent = true === btnTogglerP ? $btnToggler.closest('td[data-item-ordinal]') : $btn.closest("td[data-item-ordinal]");

    modalHelper.getModal(endPoint, data, $loadingIndicator, function ($mmodal) {
        let returnValue = null

        $mmodal.find(".kdr-grid").on(gridEvents.BEFORE_RENDER, function (response) { returnValue = response.returnValue })

        $mmodal.one("hide.bs.modal", function () {
            let lambdas = $._data($control[0], "events")

            controls.refreshWithInputs(
                $control,
                gridId,
                undefined,
                controls.getEndpoint($control),
                null,
                function ($hehe) {
                    if (lambdas != undefined) {
                        $._data($hehe[0], "events", lambdas)
                    }

                    if ($hehe.eq(0).hasClass('kdr-filters')) {
                        $hehe.eq(0).one(gridEvents.AFTER_RENDER_W_INPUTS, function () {
                            controls.invokeCommands($(this))
                        })
                    }
                },
                {
                    index: $btnTDParent.find(".kdr-grid-input, .kdr-filters-input").data("index"),
                    itemOrdinal: $btnTDOrdinalParent.closest("td[data-item-ordinal]").data("itemOrdinal"),
                    value: returnValue
                }
            )
        })
    })
})

$(document).on('click', '.kdr-grid-files-list .kdr-grid-file-item-download, .kdr-grid-input-file-list .kdr-grid-file-item-download', function () {
    let $downloadButton = $(this)
    let $fileItem = $downloadButton.closest('.kdr-grid-file-item');
    let $cointainer = $fileItem.closest('.kdr-grid-files-list , .kdr-grid-input-file-list')
    let $grid = $fileItem.closest('.kdr-grid').length == 0 ? controls.getControl($fileItem.closest('.modal').attr('for')) : $fileItem.closest('.kdr-grid')

    if (!$downloadButton.closest('td').hasClass('kdr-grid-do-not-download-file')) {
        controls.downloadGridFile(controls.getInfo($grid), $cointainer.data('action'), $cointainer.data('index'), $fileItem.data('index'), $fileItem, false)
    }
})

$(document).on('click', '.kdr-grid-files-list .kdr-grid-files-download-all', function () {
    let $downloadButton = $(this)
    let $cointainer = $downloadButton.closest('.kdr-grid-files-list')
    let $grid = $downloadButton.closest('.kdr-grid')
    let $td = $downloadButton.closest('td')
    controls.downloadGridAllFiles(controls.getInfo($grid), $cointainer.data('action'), $cointainer.data('index'), $td)
})

$(document).on('change', '.kdr-grid-files-input', function () {
    let $input = $(this)
    controls.fileControl.refreshUI($input)
})

$(document).on('click', '.kdr-grid-files-input-label', (e) => {
    let $target = $(e.target)
    if ($target.hasClass('kdr-grid-files-input-label-picker') == false && $target.closest('.kdr-grid-files-input-label-picker').length == 0) {
        e.preventDefault()
    }
})

$(document).on('mouseenter', '.kdr-grid-file-tooltip', function () {
    let $fileItem = $(this)
    if ($fileItem.data('tooltiptInitiated') === true) {
        return false
    }

    let $grid = $fileItem.closest('.kdr-grid').length == 0 ? controls.getControl($fileItem.closest('.modal').attr('for')) : $fileItem.closest('.kdr-grid')
    let info = controls.getInfo($grid)
    let magic = $fileItem.closest('.kdr-grid-files-list , .kdr-grid-input-file-list').data('action')
    let fileIndex = $fileItem.closest('.kdr-grid-file-item').data('index')
    let columnIndex = $fileItem.closest('.kdr-grid-files-list , .kdr-grid-input-file-list').data('index')

    $.ajax({
        type: "POST",
        url: __root + 'Grid/GetFileInfo',
        datatype: "json",
        traditional: true,
        data: {
            info: info,
            magic: magic,
            columnIndex: columnIndex,
            itemIndex: fileIndex
        },
        success: function (response) {
            if (response.code == gridResponseCodes.SUCCESS) {
                let creationDate = response.args[0]
                let filesize = response.args[1]

                let tooltipText = textHelper.format(
                    $fileItem.data('titleTemplate'),
                    filesize,
                    creationDate)
                $fileItem
                    .attr('data-original-title', tooltipText)
                    .removeAttr('data-title-template')
                $fileItem.data('tooltiptInitiated', true)

                if ($fileItem.is(':hover')) {
                    $fileItem.tooltip('show')
                }
            }
        },
        beforeSend: () => {
            $fileItem.find('> .btn').css('cursor', 'progress')
        },
        complete: () => {
            $fileItem.find('> .btn').css('cursor', '')
        }
    })
})

/* ten kod jest prawie taki sam jak nizej */
$(document).on('click', '.kdr-grid-on-success-close-modal', function () {
    let $this = $(this)
    let controlId = $this.attr('control-id')
    let $m = $this.closest('.modal')
    let removeP = !$this.hasClass('kdr-grid-on-success-close-modal-do-not-remove')

    if (!$this.hasClass('kdr-grid-perform-all-custom-ones') && !$this.hasClass('kdr-grid-perform-all-custom-ones-refresh') && !$this.hasClass('kdr-grid-perform-all-save-all-ext')) {
        let $control = controls.getControl(controlId)
        loading.show($this)
        $control.one(gridEvents.BEFORE_RENDER, function (event) {
            loading.hide($this)

            if (event.code == gridResponseCodes.SUCCESS) {
                if (removeP) {
                    modalHelper.removeModalFromBody($m)
                }
                else {
                    $m.modal('hide')
                }
            }
        })
    } else {
        $this.one('done', function (response) {
            if (response.isSuccess) {
                if (removeP) {
                    modalHelper.removeModalFromBody($m)
                }
                else {
                    $m.modal('hide')
                }
            }
        })
    }
})

/* ten kod jest prawie taki sam jak wyzej */
$(document).on('click', '.kdr-grid-on-non-error-close-modal', function () {
    let $this = $(this)
    let controlId = $this.attr('control-id')
    let $m = $this.closest('.modal')
    let removeP = !$this.hasClass('kdr-grid-on-success-close-modal-do-not-remove')

    if (!$this.hasClass('kdr-grid-perform-all-custom-ones') && !$this.hasClass('kdr-grid-perform-all-custom-ones-refresh') && !$this.hasClass('kdr-grid-perform-all-save-all-ext')) {
        let $control = controls.getControl(controlId)
        loading.show($this)
        $control.one(gridEvents.BEFORE_RENDER, function (event) {
            loading.hide($this)

            if (event.code != gridResponseCodes.ERROR) {
                if (removeP) {
                    modalHelper.removeModalFromBody($m)
                }
                else {
                    $m.modal('hide')
                }
            }
        })
    } else {
        $this.one('done', function (response) {
            if (response.isSuccess) {
                if (removeP) {
                    modalHelper.removeModalFromBody($m)
                }
                else {
                    $m.modal('hide')
                }
            }
        })
    }
})

$(document).on('click', '.kdr-grid-on-success-refresh', function () {
    let $this = $(this)
    let $control = controls.getControl($this.attr('control-id'))
    let $refreshTargets = $($this.data('refreshTarget'))

    let endpoint = $this.data('refreshEndpoint')

    $control.one(gridEvents.BEFORE_RENDER, function (event) {
        if (event.code == gridResponseCodes.SUCCESS) {
            $refreshTargets.each(function () {
                controls.refresh($(this), null, null, endpoint)
            })
        }
    })
})

/* ten kod jest prawie taki sam jak wyzej, moze przekazac zamkniecie z funkcja sprawdzajaca i wygenerowac dwie funkcje? to samo z close modalem */
$(document).on('click', '.kdr-grid-on-non-error-refresh', function () {
    let $this = $(this)
    let $control = controls.getControl($this.attr('control-id'))
    let $refreshTargets = $($this.data('refreshTarget'))

    let endpoint = $this.data('refreshEndpoint')

    $control.one(gridEvents.BEFORE_RENDER, function (event) {
        if (event.code != gridResponseCodes.ERROR) {
            $refreshTargets.each(function () {
                controls.refresh($(this), null, null, endpoint)
            })
        }
    })
})

$(document).on('click', '.kdr-grid-on-success-refresh-with-inputs', function () {
    let $this = $(this)
    let $control = controls.getControl($this.attr('control-id'))
    let $refreshTargets = $($this.data('refreshTarget'))

    let endpoint = $this.data('refreshEndpoint')

    $control.one(gridEvents.BEFORE_RENDER, function (event) {
        if (event.code == gridResponseCodes.SUCCESS) {
            $refreshTargets.each(function () {
                controls.refreshWithInputs($(this), null, null, endpoint)
            })
        }
    })
})

$(document).on('click', '.kdr-grid-on-success-refresh-with-clear-checkboxes', function () {
    let $this = $(this)
    let $control = controls.getControl($this.attr('control-id'))
    let $refreshTargets = $($this.data('refreshTarget'))

    let endpoint = $this.data('refreshEndpoint')

    $control.one(gridEvents.BEFORE_RENDER, function (event) {
        if (event.code == gridResponseCodes.SUCCESS) {
            $refreshTargets.each(function () {
                controls.refresh($(this), null, null, endpoint, null, null, true)
            })
        }
    })
})

$(document).on('click', '.kdr-grid-on-success-return-site', function () {
    let $this = $(this)
    let controlId = $this.attr('control-id')
    let $control = controls.getControl(controlId)
    loading.show($this)

    $control.one(gridEvents.BEFORE_RENDER, function (event) {
        loading.hide($this)

        if (event.code == gridResponseCodes.SUCCESS) {
            site.goBack()
        }
    })
})

$(document).on('click', '.kdr-grid-edit-for-all-inputs', function () {
    let $this = $(this)
    $this.closest('.kdr-grid-column-header').find('.kdr-grid-edit-for-all-inputs').toggleClass('hide')

    let $header = $this.closest('.kdr-grid-column-header').find('a')
    let $editInput = $this.closest('.kdr-grid-column-header').find('.grid-header-edit-cell')
    $header.toggleClass('hide')
    $editInput.toggleClass('hide')
})

$(document).on('click', '.kdr-grid-developer-mode-btn', function () {
    let $this = $(this)
    let $grid = $this.closest('.kdr-grid')

    $.ajax({
        type: "POST",
        url: window.location.origin + __root + 'Grid/ToggleDeveloperMode',
        datatype: "text",
        traditional: true,
        data: { info: controls.getInfo($grid) },
        success: function (newInfo) {
            controls.setInfo($grid, newInfo)

            if($this.hasClass('btn-outline-success')){
                $this.html('DEV Mode: OFF')
                $this.removeClass('btn-outline-success')
                $this.addClass('btn-outline-danger')
            }else{
                $this.html('DEV Mode: ON')
                $this.removeClass('btn-outline-danger')
                $this.addClass('btn-outline-success')
            }
            //controls.refresh($grid)
        }
    })
})

function inputArgs(element) {
    let that = element
    let grid = that.closest(".kdr-grid")
    let gridId = grid.attr('id')

    let item = that.closest(".kdr-grid-item-insert")

    let inputs = item.find(".kdr-grid-input")
    let args = {}
    controls.getArgs(inputs, args)

    return JSON.stringify(args);
}

function updateArgs(element) {
    let that = element
    let grid = that.closest(".kdr-grid")

    let ordinal = that.closest("td").data("itemOrdinal")

    let inputs = grid.find('td[data-item-ordinal="' + ordinal + '"] .kdr-grid-input')
    let args = {}
    controls.getArgs(inputs, args)

    return JSON.stringify(args);
}

function customOneParameters(element) {
    let that = element
    let grid = that.closest(".kdr-grid")
    let actions = $(grid).find(".kdr-grid-save-action[data-operation-type=Update]")

    let payload = []

    actions.each(function (a, b) {
        let c = $(b)
        let item = c.closest(".kdr-grid-item-update")
        //let inputs = item.children().children(".kdr-grid-input")
        let inputs = item.find(".kdr-grid-input")
        let args = {}
        controls.getArgs(inputs, args)
        payload.push(
            {
                magic: c.attr("data-action"),
                args: args
            })
    })

    return JSON.stringify(payload);
}

function saveAll(element) {
    let that = element
    let grid = that.closest(".kdr-grid")
    let op = that.attr("data-operation-type")
    let actions = $(grid).find(".kdr-grid-save-action[data-operation-type=" + op + "]")
    let payload = []
    actions.each(function (a, b) {
        let c = $(b)
        let item = c.closest(".kdr-grid-item-update")
        //let inputs = item.children().children(".kdr-grid-input")
        let inputs = item.find(".kdr-grid-input")
        let args = {}
        controls.getArgs(inputs, args)
        payload.push(
            {
                magic: c.attr("data-action"),
                args: args
            })
    })

    return JSON.stringify(payload)
}

function saveAllToggle() {
    if ($('.developer').css("display") == "none") {
        $('.developer').show()
    } else {
        $('.developer').hide()
    }
}

$(document).on('click', '.kdr-grid-show-spell', function () {
    let $this = $(this)
    let $grid = $this.closest(".kdr-grid")
    let gridId = $grid.attr('id')
    let inputs;

    let files = controls.getFiles(gridId)
    let progressText = files != undefined && files.length > 0 ? __l.Sending : undefined

    let ordinal = $this.closest("td").data("itemOrdinal")

    if (ordinal != null) {
        inputs = $grid.find('td[data-item-ordinal="' + ordinal + '"] .kdr-grid-input')
    }
    else {
        ordinal = $this.closest("div.oridinal-class").attr('data-item-ordinal')
        inputs = $grid.find('div[data-item-ordinal="' + ordinal + '"] .kdr-grid-input');
    }
    /*console.log(ordinal)*/

    if (inputs.length === 0) {
        ordinal = $this.closest(".oridinal-class").data("itemOrdinal");
        inputs = $grid.find('.oridinal-class[data-item-ordinal="' + ordinal + '"] .kdr-grid-input');
    }

    let args = {}
    controls.getArgs(inputs, args)

    let formData = new FormData();
    formData.append('info', controls.getInfo($grid))
    formData.append('magic', $this.attr("data-action"))
    formData.append('args', JSON.stringify(args))
    if (controls.appendFilesToFormData(formData, files, $grid) === false) {
        return false
    }

    //modalHelper.getModal('Grid/ShowSpellInfo', formData)

    $.ajax({
        type: "POST",
        url: __root + "Grid/ShowSpellInfo",
        datatype: "json",
        traditional: true,
        contentType: false,
        processData: false,
        data: formData,
        success: function (response) {
            if (response.code == gridResponseCodes.WARNING) {
                modal.getModal.warning("~{Warning}", response.message, true)
            } else if (response.code == gridResponseCodes.INFO) {
                modal.getModal.info("~{Info}", response.message, true)
            } else if (response.code == gridResponseCodes.ERROR) {
                modal.getModal.danger(__l.Error, response.message, true)
            } else {

                let $modal
                if (!(undefined == response || null == response || response == '')) {
                    $modal = modalHelper.addModalToBody(response)
                }
            }
        },
        error: function (response) {
            modal.getModal.danger(response.status, response.statusText, true)
        },
        beforeSend: function () {
            loading.show()
        },
        complete: function () {
            loading.hide()
        }
    })
})

$(document).on('click', '.kdr-new-grid tr .arrow', function (e) {
    e.preventDefault();


    const $tr = $(this).closest('tr:not(.kdr-gridfooter)');
    const $table = $tr.closest('table')

    const trOrdinal = $tr.data('rowOrdinal')

    const $detailsRow = $table.find('.toggle-row[data-row-ordinal="' + trOrdinal + '"]') //$tr.next();
    const $sub = $detailsRow.find('.sub-table-wrap');

    $tr.siblings('tr').removeClass('active');
    $('.kdr-new-grid .sub-table-wrap').not($sub).slideUp('fast');

    const isOpening = !$sub.is(':visible');
    const selector = 'tr[data-row-ordinal="' + trOrdinal + '"]:not(.toggle-row)'
    if (isOpening) {
        $table.find(selector).addClass('active')
    } else {
        $table.find(selector).removeClass('active')
    }

    function _getScrollParent($el) {
        const $parents = $el.parents();
        for (let i = 0; i < $parents.length; i++) {
            const $p = $parents.eq(i);
            const oy = ($p.css('overflow-y') || '').toLowerCase();
            if (/(auto|scroll)/.test(oy) && $p.innerHeight() < $p[0].scrollHeight) {
                return $p;
            }
        }
        return $(window);
    }

    function _smartScroll($el) {
        const $container = _getScrollParent($el);
        const padding = 12;

        if ($container[0] === window) {
            const viewTop = $(window).scrollTop();
            const viewBottom = viewTop + $(window).height();
            const elTop = $el.offset().top;
            const elBottom = elTop + $el.outerHeight();

            // sprawdzenie czy rozwijadło wyjechało poza ekran
            if (elBottom > viewBottom) {
                $('html, body').stop(true).animate(
                    { scrollTop: elBottom - $(window).height() + padding },
                    250
                );
            } else if (elTop < viewTop) {
                $('html, body').stop(true).animate(
                    { scrollTop: elTop - padding },
                    250
                );
            }
        } else {
            const containerTop = $container.offset().top;
            const viewTop = $container.scrollTop();
            const viewBottom = viewTop + $container.innerHeight();

            const elTop = $el.offset().top - containerTop + viewTop;
            const elBottom = elTop + $el.outerHeight();

            if (elBottom > viewBottom) {
                $container.stop(true).animate(
                    { scrollTop: elBottom - $container.innerHeight() + padding },
                    250
                );
            } else if (elTop < viewTop) {
                $container.stop(true).animate(
                    { scrollTop: elTop - padding },
                    250
                );
            }
        }
    }

    $sub.stop(true, true).slideToggle(200, function () {
        if (!isOpening) return;

        if (this.scrollIntoView) {
            this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            return;
        }

        _smartScroll($(this));
    });
});

$(document).on('click', '.kdr-grid-click-to-render', function (e) {
    $this = $(this)

    $.ajax({
        type: "POST",
        url: __root + "Grid/ClickToRender",
        datatype: "json",
        traditional: true,
        data: { info: controls.getInfo($this.closest('.kdr-grid')) },
        success: function (response) {
            if (response.code == gridResponseCodes.WARNING) {
                modal.getModal.warning("~{Warning}", response.message, true)
            } else if (response.code == gridResponseCodes.INFO) {
                modal.getModal.info("~{Info}", response.message, true)
            } else if (response.code == gridResponseCodes.ERROR) {
                modal.getModal.danger(__l.Error, response.message, true)
            } else {
                $grid = $this.closest('.kdr-grid')

                controls.setInfo($grid, response.message)
                controls.refresh($grid)
            }
        },
        error: function (response) {
            modal.getModal.danger(response.status, response.statusText, true)
        },
        beforeSend: function () {
            loading.show($this)
        },
        complete: function () {
            loading.hide($this)
        }
    })
})

$(document).on('change', '.element-toggle', function () {
    let $elements = $('.element-to-hide').toggleClass('hide-tr')
})
//#endregion Grid